import {
  getPMICalculation,
  getPrincipleInterest,
  getPropertyInsurance,
  getRemainingInterest,
  getLoanTotalAmount,
} from '@elevationscu/common-mortgage-calculator';
import {
  Button,
  Col,
  CurrentLoanAssumptionModal,
  MortgageHeader,
  CurrentPayment,
  PropertyInfoPopUp,
  Row,
  SaveProposalModal,
  TopDataEntrySection,
  REASONS_FOR_REFINANCE,
  Alert,
  Modal,
  Heading,
  CardsComponent,
} from '@elevationscu/ui-component-lib';
import axios from 'axios';
import {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from 'react';
import { useSearchParams, useLoaderData } from 'react-router-dom';
import { AggregatedData } from '../classes/AggregatedData';
import { CashOut } from '../classes/CashOut';
import { ContactInformation } from '../classes/ContactInformation';
import { FicoInfo } from '../classes/FicoInfo';
import { LoanAssumptions } from '../classes/LoanAssumptions';
import { LoanInfo } from '../classes/LoanInfo';
import { PropertyInfo } from '../classes/PropertyInfo';
import { ClosingCosts } from '../classes/closing-costs/ClosingCosts';
import { TitleBanner, AmortizationTable } from '../components/index';
import { getLoanOfficers, getSelectedLO } from '../services/officerService';
import getPropertyDetails from '../services/propertyDetails';
import { updateApplicant } from '../services/prospectService';
import {
  invokeOptimalBlue,
  invokeHomeEquityRate,
  filterCard,
  getOccupancy,
  getPropertyType,
  getNumberOfUnits,
  getInputFromName,
  getLoanPurposeFromCard,
} from '../services/optimal-blue/Invoke';
import { determineHelocAmount } from '../services/homeEquityRules';
import { ERROR_PROPERTY_TYPES } from '../constants/propertyTypes';
import { CREDIT_SCORES } from '../utils/ficoScoreMapper';
import '../styles/common.scss';
import {
  calculateEstimatedMonthlyPayment,
  calculateTotalCurrentMortgageAmount,
  handleAddressChange,
  isDifferenceGreaterThan30Days,
  getDefaultCards,
  isStreamlinedOrIRRL,
  isFHAStreamlined,
  calculateFHAStreamlinedAmount,
  calculateMIPByCardType,
  calculateMIPRefund,
  normalizeList,
  buildMoreInfoDataPoints,
  getHighlightedOption,
  getDate,
  isHomeEquity,
  getApplicantSecureId,
  isValidApplicationData,

  hasHeloc,
  fixNaN,
  hasSecondLoanOnly,
  calculateLTV,
  shouldCallOB,
  getDisplayCardData,
  calculateTargetLoanAmount,
  checkErrorResponse,
  mapRateOptions,
} from '../utils/Operations';
import {
  helocClosingCostsMapping,
  refiClosingCostsMapping,
} from '../utils/ClosingCostMapping';
import './New.scss';
import { ProductSearchInput } from '../services/optimal-blue/productSearchInput';
import { LoanCompare } from '../classes/LoanCompare';
import { useClientError } from '../ClientErrorContext';
import { getSessionStorageItem, setSessionStorageItem } from '../utils/sessionStorage';
import { getHomeEquityRate } from '../services/homeEquityRateService';

function NewUser({ error }) {
  const { prospect: initialProspect, loDetails } = useLoaderData() || {};
  const [prospect, setProspect] = useState(initialProspect);
  const { clientError } = useClientError();
  const isMobile = false;
  const [isNewPaymentSectionOpen, setIsNewPaymentSectionOpen] = useState(false);
  const [hasReason, setHasReason] = useState(false);
  const [ficoInfo, setFicoInfo] = useState(new FicoInfo());
  const reasonRef = useRef(null);
  const [selectedLODetails, setSelectedLODetails] = useState(loDetails);
  const [acceptedLoanAssumption, setAcceptedLoanAssumption] = useState(false);
  const [isLoanAssumptionModalOpen, setIsLoanAssumptionModalOpen] = useState(false);

  const [emailSentModal, setEmailSentModal] = useState(false);
  const [newApplicantURL, setNewApplicantURL] = useState('');
  const [saveProposalResults, setSaveProposalResults] = useState(new ContactInformation());
  const [currentLoanAssumptions, setCurrentLoanAssumptions] = useState();
  const [cashOutResults, setCashOutResults] = useState(new CashOut());
  const [propertyInfo, setPropertyInfo] = useState(new PropertyInfo());
  const [propertyIdentifier, setPropertyIdentifier] = useState(0);
  const [aggregatedData, setAggregatedData] = useState(new AggregatedData());
  const [loanOfficers, setLoanOfficers] = useState([]);
  const [apiPostError, setApiPostError] = useState(false);
  const [pendingSave, setPendingSave] = useState(null);
  const hasShownPropertyModal = useRef(false);
  const [shouldShowPropertyModal, setShouldShowPropertyModal] = useState(false);
  const amortizationRef = useRef();

  const [isProspect, setIsProspect] = useState(!!prospect);
  const [helocClosingCostsData, setHelocClosingCostsData] = useState(new ClosingCosts());
  const [refiClosingCostsData, setRefiClosingCostsData] = useState(new ClosingCosts());

  const [selectedLoanType, setSelectedLoanType] = useState('REFI');
  // Optimal Blue
  const [selectedCardOne, setSelectedCardOne] = useState('');
  const [selectedCardTwo, setSelectedCardTwo] = useState('');
  const [selectedCardThree, setSelectedCardThree] = useState('');
  const [allCardsData, setAllCardsData] = useState([]);

  const [cardOneData, setCardOneData] = useState(new LoanCompare());
  const [cardTwoData, setCardTwoData] = useState(new LoanCompare());
  const [cardThreeData, setCardThreeData] = useState(new LoanCompare());
  const [initialTotalLoanAmount, setInitialTotalLoanAmount] = useState(0);
  const [totalLoanAmountCardOne, setTotalLoanAmountCardOne] = useState(initialTotalLoanAmount);
  const [totalLoanAmountCardTwo, setTotalLoanAmountCardTwo] = useState(initialTotalLoanAmount);
  const [totalLoanAmountCardThree, setTotalLoanAmountCardThree] = useState(initialTotalLoanAmount);
  const [autoRecalculate, setAutoRecalculate] = useState([
    { buttonType: null }, // card 0
    { buttonType: null }, // card 1
    { buttonType: null }, // card 2
  ]);
  const [selectedCardId, setSelectedCardId] = useState('card1');
  const [cardOneVisible] = useState(true);
  const [cardTwoVisible, setCardTwoVisible] = useState(true);
  const [cardThreeVisible, setCardThreeVisible] = useState(true);
  const [newCardIndex, setNewCardIndex] = useState(null);
  const isInitialFetchRunning = useRef(false);
  const initialFetchCompletedCardsRef = useRef(new Set());

  // messages in OB cards
  const [rateDate, setRateDate] = useState('...');
  const [cardErrors, setCardErrors] = useState([undefined, undefined, undefined]);

  const [isObExecuting, setIsObExecuting] = useState(false);
  const [isCardOneLoading, setIsCardOneLoading] = useState(false);
  const [isCardTwoLoading, setIsCardTwoLoading] = useState(false);
  const [isCardThreeLoading, setIsCardThreeLoading] = useState(false);
  const setAllCardsLoading = (value) => {
    setIsCardOneLoading(value);
    setIsCardTwoLoading(value);
    setIsCardThreeLoading(value);
  };

  const clearAllCardErrors = () => setCardErrors([undefined, undefined, undefined]);

  const setCardError = (index, message) => {
    setCardErrors((prev) => {
      const next = [...prev];
      next[index] = message;
      return next;
    });
  };
  const [showPropertyTypeModalError, setShowPropertyTypeModalError] = useState(false);
  const [loanCompareSectionShowMore, setLoanCompareSectionShowMore] = useState(false);
  const [shouldCallValueCheck, setShouldCallValueCheck] = useState(prospect?.application_data?.shouldCallValueCheck || true);
  const applyLink = useMemo(() => {
    const baseUrl = 'https://applymortgage.elevationscu.com/';
    return (selectedLODetails?.first_name && selectedLODetails?.last_name)
      ? `${baseUrl}signup?referrerId=${selectedLODetails.first_name}.${selectedLODetails.last_name}%40elevationscu.com`
      : `${baseUrl}#/sso-start`;
  }, [selectedLODetails]);

  const cardsMapData = useMemo(() => ({
    card1: cardOneData,
    card2: cardTwoData,
    card3: cardThreeData,
  }), [cardOneData, cardTwoData, cardThreeData]);

  const fhaStreamlinedAmount = useMemo(() => {
    const balance = currentLoanAssumptions?.estimatedMortageBalance ?? 0;
    const thirtyDaysInterest = refiClosingCostsData?.estimatedPrepaidExpenses?.interimInterestAmount ?? 0;
    return calculateFHAStreamlinedAmount(balance, thirtyDaysInterest);
  }, [currentLoanAssumptions, refiClosingCostsData]);

  // Display amount includes MIP (1.75%) - OB calls use fhaStreamlinedAmount (without MIP)
  const fhaStreamlinedDisplayAmount = useMemo(
    () => Math.round(fhaStreamlinedAmount * 1.0175),
    [fhaStreamlinedAmount],
  );

  // we need this variable to know when to reload default loan cards on reason change on saved urls. The first time we need to show saved loan cards from db and then use default cards when reason changes
  const isFirstTimeOnSavedURLForReasonChange = useRef(true);
  const haveLoanOfficerContactMeFlag = useRef('Not Now');
  const propertyInfoModalSessionStorageKey = 'shouldShowPropertyInfoModal';
  const [searchParams] = useSearchParams();
  const [rateOptions, setRateOptions] = useState([]);
  const [selectedRateCardOne, setSelectedRateCardOne] = useState(null);
  const [selectedRateCardTwo, setSelectedRateCardTwo] = useState(null);
  const [selectedRateCardThree, setSelectedRateCardThree] = useState(null);

  const [cardOneRateChanged, setCardOneRateChanged] = useState(false);
  const [cardTwoRateChanged, setCardTwoRateChanged] = useState(false);
  const [cardThreeRateChanged, setCardThreeRateChanged] = useState(false);

  const recalculateCashAtClosing = useCallback((loan, totalLoanAmount) => {
    const isHE = isHomeEquity(loan?.selectedLoan);
    const activeClosingCosts = isHE ? helocClosingCostsData : refiClosingCostsData;
    const baseClosingCosts = activeClosingCosts?.fundsAtClosing?.closingCosts ?? 0;
    const discountOrRebate = loan?.discountOrRebate ?? 0;
    let adjustedClosingCosts = baseClosingCosts;
    if (loan?.hasDiscount === true) {
      adjustedClosingCosts = baseClosingCosts + discountOrRebate;
    } else if (loan?.hasDiscount === false) {
      adjustedClosingCosts = baseClosingCosts - discountOrRebate;
    }

    const currentMortgageBalance = currentLoanAssumptions?.estimatedMortageBalance ?? 0;
    const cashAtClosing = isHE
      ? totalLoanAmount - adjustedClosingCosts - Number(activeClosingCosts?.fundsAtClosing?.prepaidExpenses ?? 0)
      : totalLoanAmount - currentMortgageBalance - (activeClosingCosts?.fundsAtClosing?.secondLoan ?? 0) - adjustedClosingCosts - Number(activeClosingCosts?.fundsAtClosing?.prepaidExpenses ?? 0);
    const ltvLoanAmount = isHE ? currentMortgageBalance + totalLoanAmount : totalLoanAmount;
    const usesSaleAmount = isFHAStreamlined(loan?.selectedLoan) || isStreamlinedOrIRRL(loan?.selectedLoan);
    const ltvAppraisedValue = usesSaleAmount ? (ficoInfo?.saleAmount || currentLoanAssumptions?.estimatedHomeValue) : currentLoanAssumptions?.estimatedHomeValue;
    const loanToValue = calculateLTV(ltvLoanAmount, ltvAppraisedValue);
    const roundedCash = Math.round(cashAtClosing);

    let dueOrRefund = 'due';
    if (roundedCash > 0) {
      dueOrRefund = 'refund';
    }

    return {
      ...loan,
      cashAtClosing: roundedCash,
      cashDueOrRefundAtClosing: dueOrRefund,
      loanToValue,
    };
  }, [helocClosingCostsData, refiClosingCostsData, currentLoanAssumptions, ficoInfo]);

  // Differs from recalculateCashAtClosing: that one trusts loan.discountOrRebate as-is, while this one calculates discountOrRebate based on the card's price and the totalLoanAmount passed in.
  const previewCashAtClosingForAmount = useCallback((cardData, selectedLoan, totalLoanAmount) => {
    const ratePrice = cardData?.price ?? 100;
    let hasDiscount;
    if (ratePrice < 100) hasDiscount = true;
    else if (ratePrice > 100) hasDiscount = false;
    const { cashAtClosing } = recalculateCashAtClosing({
      selectedLoan,
      hasDiscount,
      discountOrRebate: totalLoanAmount * Math.abs((ratePrice - 100) / 100),
    }, totalLoanAmount);
    return cashAtClosing;
  }, [recalculateCashAtClosing]);

  const handleRateUpdate = (newLoan, cardId) => {
    switch (cardId) {
      case 'card1':
        setCardOneData(recalculateCashAtClosing(newLoan, totalLoanAmountCardOne));
        setSelectedRateCardOne(newLoan?.interestRate ?? null);
        setCardOneRateChanged(true);
        break;
      case 'card2':
        setCardTwoData(recalculateCashAtClosing(newLoan, totalLoanAmountCardTwo));
        setSelectedRateCardTwo(newLoan?.interestRate ?? null);
        setCardTwoRateChanged(true);
        break;
      case 'card3':
        setCardThreeData(recalculateCashAtClosing(newLoan, totalLoanAmountCardThree));
        setSelectedRateCardThree(newLoan?.interestRate ?? null);
        setCardThreeRateChanged(true);
        break;
      default: break;
    }
  };

  const [isSaveProposalModalOpen, setIsSaveProposalModalOpen] = useState(false);

  // redirect the user after save proposal.
  const handleReturnToMyProposals = () => {
    setEmailSentModal(false);
    window.location.replace(newApplicantURL);
    // need to force a reload because the new part in the newApplicantURL starts with #/{id} and any change to the url starting with hash is considered the same document for browser's window object
    window.location.reload();
  };

  const initializedRef = useRef(false);
  const heAmountsRef = useRef([totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree]);
  const previousCashOutRef = useRef([false, false, false]);
  const previousOBInputsRef = useRef([null, null, null]);

  useEffect(() => {
    if (initialTotalLoanAmount > 0 && !initializedRef.current) {
      const cashReq = cashOutResults?.cashReq || 0;
      const loanAmountsKey = `totalLoanAmounts_${getApplicantSecureId() || 'new'}`;
      let cached = null;
      try {
        cached = JSON.parse(localStorage.getItem(loanAmountsKey));
      } catch {
        cached = null;
      }
      const savedAmounts = cached?.cashReq === cashReq ? cached.amounts : null;
      const helocDefault = cashReq;
      const refiDefault = initialTotalLoanAmount + cashReq;
      setTotalLoanAmountCardOne(isHomeEquity(selectedCardOne) ? helocDefault : (savedAmounts?.[0] || refiDefault));
      setTotalLoanAmountCardTwo(isHomeEquity(selectedCardTwo) ? helocDefault : (savedAmounts?.[1] || refiDefault));
      setTotalLoanAmountCardThree(isHomeEquity(selectedCardThree) ? helocDefault : (savedAmounts?.[2] || refiDefault));
      setAutoRecalculate([
        { buttonType: isHomeEquity(selectedCardOne) || isFHAStreamlined(selectedCardOne) ? null : 'onePayment' },
        { buttonType: isHomeEquity(selectedCardTwo) || isFHAStreamlined(selectedCardTwo) ? null : 'onePayment' },
        { buttonType: isHomeEquity(selectedCardThree) || isFHAStreamlined(selectedCardThree) ? null : 'onePayment' },
      ]);
      initializedRef.current = true;
    }
  }, [initialTotalLoanAmount, selectedCardOne, selectedCardTwo, selectedCardThree, cashOutResults?.cashReq]);

  useEffect(() => {
    if (totalLoanAmountCardOne || totalLoanAmountCardTwo || totalLoanAmountCardThree) {
      const loanAmountsKey = `totalLoanAmounts_${getApplicantSecureId() || 'new'}`;
      localStorage.setItem(loanAmountsKey, JSON.stringify({
        cashReq: cashOutResults?.cashReq || 0,
        amounts: [totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree],
      }));
    }
  }, [totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree, cashOutResults?.cashReq]);

  const setTotalLoanAmountForCard = useCallback((cardIndex, value) => {
    if (cardIndex === 0) setTotalLoanAmountCardOne(value);
    else if (cardIndex === 1) setTotalLoanAmountCardTwo(value);
    else if (cardIndex === 2) setTotalLoanAmountCardThree(value);
  }, []);

  const handleReasonChange = (reason) => {
    setAggregatedData((prev) => ({ ...prev, refiReason: reason }));
    setCashOutResults((prev) => ({ ...prev, refiReason: reason }));
    if (!hasShownPropertyModal.current && getSessionStorageItem(propertyInfoModalSessionStorageKey) === 'true') {
      setShouldShowPropertyModal(true);
      hasShownPropertyModal.current = true;
    }

    if (prospect && reason && reason !== prospect?.application_data?.primary_reason && isFirstTimeOnSavedURLForReasonChange.current) {
      isFirstTimeOnSavedURLForReasonChange.current = false;
    }
  };

  const handleCreditScore = async (creditScore) => {
    setAggregatedData((prev) => ({
      ...prev,
      user_credit: creditScore,
    }));

    const updatedFicoInfo = { ...ficoInfo, fico: CREDIT_SCORES.get(creditScore) };
    const pmiCalculation = getPMICalculation(updatedFicoInfo);
    const pmi = (!isDifferenceGreaterThan30Days(updatedFicoInfo?.saleDate, updatedFicoInfo?.docDate) && (typeof pmiCalculation === 'number')) ? Math.ceil(pmiCalculation) : 0;

    setCurrentLoanAssumptions((prev) => new LoanAssumptions({
      ...prev,
      estimatedMortgageInsurance: pmi,
      estimatedMonthlyPayment: calculateEstimatedMonthlyPayment(prev?.estimatedPrincipalAndInterest, prev?.estimatedTaxes, prev?.estimatedPropertyInsurance, prev?.estimatedFloodInsurance, pmi),
    }));

    setFicoInfo(updatedFicoInfo);

    // if tempAssumptions has more than one loan, then we do the recalc.
    if (currentLoanAssumptions?.estimatedSecondMortgageBalance && !acceptedLoanAssumption) {
      let secondLoanInterestRate = currentLoanAssumptions.estimatedSecondInterestRate;
      let secondMonthlyPayment = 0;
      let loanType = '';
      const ltv = (parseFloat(currentLoanAssumptions?.estimatedMortageBalance) + parseFloat(currentLoanAssumptions?.estimatedSecondMortgageBalance)) / parseFloat(currentLoanAssumptions?.estimatedHomeValue);
      const score = CREDIT_SCORES.get(creditScore);
      if (hasHeloc(currentLoanAssumptions?.estimatedSecondCurrentLoanType)) {
        loanType = 'Home Equity Line of Credit';
        const response = await getHomeEquityRate(loanType, ltv, score);
        let rate = 0;
        if (response?.status === 200) {
          if (response?.data?.interest_rate) {
            rate = JSON.parse(response?.data?.interest_rate);
          }
        }
        secondLoanInterestRate = fixNaN(parseFloat(rate) || 0);
        secondMonthlyPayment = fixNaN(parseFloat(currentLoanAssumptions?.estimatedSecondMortgageBalance) * ((secondLoanInterestRate / 100) / 12));
      } else {
        const secondTerm = currentLoanAssumptions?.secondLoanTerm;
        const interestRate = secondLoanInterestRate / 100;
        const currentBalance = fixNaN(parseFloat(currentLoanAssumptions?.estimatedSecondMortgageBalance));
        const originalBalance = fixNaN(parseFloat(currentLoanAssumptions?.estimatedSecondCurrentLoanAmount));
        secondMonthlyPayment = getPrincipleInterest(interestRate, secondTerm, originalBalance, currentBalance);
      }

      setCurrentLoanAssumptions((prev) => ({
        ...prev,
        estimatedSecondInterestRate: secondLoanInterestRate,
        estimatedSecondMonthlyPayment: secondMonthlyPayment,
      }));
    }
  };

  const evaluateError = useCallback((response, cardIndex = null, loanName = '') => {
    const { hasError, errorMessage } = checkErrorResponse(response);
    if (hasError && errorMessage) {
      let displayError = errorMessage;
      if (isFHAStreamlined(loanName)) {
        displayError = (
          <>
            The selected loan is unavailable. FHA Streamline loans have strict requirements. You may be able to
            {' '}
            <strong>lower loan total</strong>
            {' '}
            or use the standard FHA 30 Year Fixed. Feel free to call us at 800.460.2889 to discuss.
          </>
        );
      } else if (isStreamlinedOrIRRL(loanName)) {
        displayError = (
          <>
            The selected loan is unavailable. VA IRRL loans have strict requirements. You may be able to
            {' '}
            <strong>lower loan total</strong>
            {' '}
            or use the standard VA 30 Year Fixed. Feel free to call us at 800.460.2889 to discuss.
          </>
        );
      }
      if (cardIndex !== null) {
        setCardError(cardIndex, displayError);
      } else {
        setCardErrors([displayError, displayError, displayError]);
      }
    }
    return hasError;
  }, []);

  const applyHomeEquityRules = (ltv, cashRequested, creditScore, HEType, loanAmount, occupancyType, cardIndex = null) => {
    const rulesResult = determineHelocAmount(creditScore, ltv, cashRequested, HEType, loanAmount, occupancyType);
    if (rulesResult[0] === 0) {
      if (cardIndex !== null) setCardError(cardIndex, 'Based on the information provided, this loan is unavailable. This may be due to high Loan to Value or Jumbo loan restrictions. Feel free to call us at 800.460.2889 to discuss.');
      return false;
    }

    if (rulesResult[1] === 650) {
      const tempCashOut = cashOutResults;
      tempCashOut.addAppraisalFee = true;
      const newHelocCosts = helocClosingCostsMapping(tempCashOut);
      setHelocClosingCostsData(newHelocCosts);
    }
    return true;
  };
  // Primary function for calling heloc rules
  // const applyHomeEquityRules = (ltv, cashRequested, creditScore, HEType, loanAmount, occupancyType) => {
  //   const rulesResult = determineHelocAmount(creditScore, ltv, cashRequested, HEType, loanAmount, occupancyType);
  //   // eslint-disable-next-line
  //   console.log('rules returned', rulesResult, 'the first number is the amount allowed it will return 0 if it is over. The second number is the appraisal fee');
  //   if (rulesResult[1] === 650) {
  //     const tempCashOut = cashOutResults;
  //     tempCashOut.addAppraisalFee = true;
  //     const newHelocCosts = helocClosingCostsMapping(tempCashOut);
  //     setHelocClosingCostsData(newHelocCosts);
  //   }
  //   if (rulesResult[0] === 0) {
  //     return false;
  //   }
  //   return true;
  // };

  const getRates = useCallback(async (searchInput, selectedLoan, refiReason, homeEquityValues, refiClosingCosts, userCredit, hasError, ltv = cashOutResults?.ltv, cardIndex = null) => {
    const promises = [];
    const isNotHomeEquity = !isHomeEquity(selectedLoan);
    const callHomeEquity = homeEquityValues?.length > 0;
    if (isNotHomeEquity) {
      searchInput.forEach((input) => {
        promises.push(invokeOptimalBlue(input, currentLoanAssumptions, refiClosingCosts, refiReason, ltv));
      });
    }

    if (callHomeEquity) {
      const loanAmount = cashOutResults.cashReq + currentLoanAssumptions.estimatedMortageBalance;
      applyHomeEquityRules(cashOutResults?.ltv, cashOutResults?.cashReq, userCredit, homeEquityValues, loanAmount, currentLoanAssumptions.occupancyType, cardIndex);
      if (applyHomeEquityRules) {
        promises.push(invokeHomeEquityRate(homeEquityValues, cashOutResults?.ltv, userCredit, currentLoanAssumptions, cashOutResults?.cashReq, refiReason, helocClosingCostsData?.fundsAtClosing?.closingCosts));
      }
    }

    const results = await Promise.all(promises);
    let hasRateError = hasError;
    if (isNotHomeEquity && !hasRateError) {
      const optimalBlueResults = results.slice(0, searchInput.length);
      optimalBlueResults.some((obResults) => {
        if (evaluateError(obResults, cardIndex, selectedLoan)) {
          hasRateError = true;
          return true;
        }
        return false;
      });
    }

    if (callHomeEquity && !hasRateError) {
      const homeEquityResult = results[results.length - 1];
      hasRateError = evaluateError(homeEquityResult, cardIndex);
    }

    return { data: results.flatMap((response) => response.data), hasOBError: hasRateError };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLoanAssumptions, cashOutResults, helocClosingCostsData, evaluateError]);

  const buildOBInputsSnapshot = useCallback((selectedCard) => ({
    creditScore: ficoInfo?.fico ?? null,
    occupancyType: currentLoanAssumptions?.occupancyType ?? null,
    propertyType: currentLoanAssumptions?.propertyType ?? null,
    savedCounty: aggregatedData?.savedCounty ?? null,
    originalLoanVal: currentLoanAssumptions?.originalLoanVal ?? null,
    saleAmount: (isFHAStreamlined(selectedCard) || isStreamlinedOrIRRL(selectedCard))
      ? (ficoInfo?.saleAmount ?? null)
      : null,
  }), [ficoInfo, currentLoanAssumptions, aggregatedData]);

  const getInitialCardsData = async (aggregationData, loanAssumption) => {
    const storedRateDate = localStorage.getItem('rateDate');
    const today = getDate();
    if (storedRateDate === today) return;
    if (!refiClosingCostsData?.fundsAtClosing || initialTotalLoanAmount <= 0) return;

    const cashReq = cashOutResults?.cashReq || 0;
    const loanAmountsKey = `totalLoanAmounts_${getApplicantSecureId() || 'new'}`;
    let savedAmounts = null;
    try {
      const cached = JSON.parse(localStorage.getItem(loanAmountsKey));
      if (cached?.cashReq === cashReq) {
        savedAmounts = cached.amounts;
      }
    } catch {
      localStorage.removeItem(loanAmountsKey);
    }

    setIsObExecuting(true);
    setAllCardsLoading(true);
    clearAllCardErrors();
    isInitialFetchRunning.current = true;

    const occupancy = getOccupancy(currentLoanAssumptions?.occupancyType.toUpperCase());
    const propertyType = getPropertyType(currentLoanAssumptions?.propertyType.toUpperCase());
    const numberOfUnits = getNumberOfUnits(currentLoanAssumptions?.propertyType.toUpperCase());
    const userCredit = CREDIT_SCORES.get(aggregationData?.user_credit);

    // HELOC cards are excluded here — handled by per-card useEffects via getHelocCardDataPerCard
    const cardDefs = [
      {
        loan: selectedCardOne, setData: setCardOneData, setLoading: setIsCardOneLoading, rateIndex: 0, savedRate: selectedRateCardOne,
      },
      {
        loan: selectedCardTwo, setData: setCardTwoData, setLoading: setIsCardTwoLoading, rateIndex: 1, savedRate: selectedRateCardTwo,
      },
      {
        loan: selectedCardThree, setData: setCardThreeData, setLoading: setIsCardThreeLoading, rateIndex: 2, savedRate: selectedRateCardThree,
      },
    ].filter(({ loan }) => loan && !isHomeEquity(loan));

    const allRawData = [];
    const cardResults = [];
    const targetAmounts = {};

    try {
      await Promise.all(cardDefs.map(async ({
        loan, setData, setLoading, rateIndex, savedRate,
      }) => {
        const inputFromName = getInputFromName(loan);
        let appraisedValue = parseFloat(loanAssumption?.estimatedHomeValue) || 0;
        if (isFHAStreamlined(loan) || isStreamlinedOrIRRL(loan)) {
          appraisedValue = ficoInfo?.saleAmount || 0;
        }
        let OBLoanAmount;
        if (isFHAStreamlined(loan)) {
          OBLoanAmount = fhaStreamlinedAmount;
        } else if (loan.toLowerCase().includes('fha')) {
          const fhaBalance = Number(loanAssumption?.estimatedMortageBalance) || 0;
          const fhaInterest = refiClosingCostsData?.estimatedPrepaidExpenses?.interimInterestAmount ?? 0;
          const fhaMip = calculateMIPByCardType(loan, fhaBalance, fhaInterest);
          OBLoanAmount = Math.round(initialTotalLoanAmount - fhaMip);
        } else {
          OBLoanAmount = initialTotalLoanAmount;
        }
        const fieldLoanAmount = isFHAStreamlined(loan) ? fhaStreamlinedDisplayAmount : initialTotalLoanAmount;
        const ltvPerCard = calculateLTV(fieldLoanAmount, appraisedValue);
        const loanNameNormalized = loan.toLowerCase();
        const isConventional = !loanNameNormalized.includes('fha') && !loanNameNormalized.includes('va');
        const isCashOut = (cashOutResults?.cashReq ?? 0) > 0;
        const loanPurpose = (isCashOut && isConventional) ? 'RefiCashout' : getLoanPurposeFromCard(loan);
        const searchInput = new ProductSearchInput(
          occupancy,
          propertyType,
          numberOfUnits,
          aggregationData?.savedCounty,
          loanAssumption?.originalLoanVal,
          appraisedValue,
          userCredit,
          OBLoanAmount,
          inputFromName.loanType,
          null, // broad fetch — all amortization types to populate allCardsData cache
          0,
          loanPurpose,
        );

        const { data: response, hasOBError } = await getRates(
          [searchInput],
          loan,
          aggregationData?.refiReason,
          [],
          refiClosingCostsData,
          userCredit,
          false,
          ltvPerCard,
          rateIndex,
        );

        allRawData.push(...response);

        const cardData = filterCard(response, loan, false, null, savedRate || null, currentLoanAssumptions?.occupancyType, OBLoanAmount);
        if (cardData?.selectedLoan) {
          let targetLoanAmount;
          if (isFHAStreamlined(loan)) {
            targetLoanAmount = fieldLoanAmount;
          } else if (savedAmounts?.[rateIndex] != null) {
            targetLoanAmount = savedAmounts[rateIndex];
          } else {
            targetLoanAmount = Math.round(calculateTargetLoanAmount('onePayment', refiClosingCostsData, currentLoanAssumptions, cardData.price || 100));
          }
          targetAmounts[rateIndex] = targetLoanAmount;

          const step1 = recalculateCashAtClosing(cardData, targetLoanAmount);
          // eslint-disable-next-line no-use-before-define
          const fullyRecalculated = recalculateCardDataWithoutOB(step1, targetLoanAmount, currentLoanAssumptions, refiClosingCostsData);
          setData(fullyRecalculated);
          // eslint-disable-next-line no-use-before-define
          updateRateOptions(rateIndex, fullyRecalculated);
          cardResults.push(fullyRecalculated);
        } else {
          const empty = new LoanCompare({}, {}, 0, 0, loan);
          empty.loanToValue = ltvPerCard;
          setData(empty);
          cardResults.push(empty);
          if (empty.error) {
            setCardError(rateIndex, 'The loan amount must be at least $10,000');
          } else if (!hasOBError) {
            setCardError(rateIndex, 'No rates returned. Please check your Loan to Value ratio.');
          }
        }
        setLoading(false);
      }));

      cardDefs.forEach(({ rateIndex, loan }) => {
        if (targetAmounts[rateIndex] !== undefined) {
          initialFetchCompletedCardsRef.current.add(rateIndex);
          previousOBInputsRef.current[rateIndex] = buildOBInputsSnapshot(loan);
          // eslint-disable-next-line no-use-before-define
          setCardButtonType(rateIndex, null);
          setTotalLoanAmountForCard(rateIndex, targetAmounts[rateIndex]);
        }
      });

      setAllCardsData([...allRawData, ...cardResults]);
      localStorage.setItem('rateDate', today);
      setRateDate(today);
    } finally {
      isInitialFetchRunning.current = false;
      setIsObExecuting(false);
      setAllCardsLoading(false);
    }
  };

  const getCardDataPerCard = useCallback(async (selectedLoan, totalLoanAmount, isCashOut, aggregationData, loanAssumption, closingCosts, selectedRate = null, cardIndex = null) => {
    setIsObExecuting(true);
    if (cardIndex !== null) setCardError(cardIndex, undefined);
    try {
      const loanNameNormalized = selectedLoan?.toLowerCase() ?? '';
      const isConventional = !loanNameNormalized.includes('fha') && !loanNameNormalized.includes('va');
      const loanPurpose = (isCashOut && isConventional) ? 'RefiCashout' : getLoanPurposeFromCard(selectedLoan);
      const occupancy = getOccupancy(currentLoanAssumptions?.occupancyType.toUpperCase());
      const propertyType = getPropertyType(currentLoanAssumptions?.propertyType.toUpperCase());
      const numberOfUnits = getNumberOfUnits(currentLoanAssumptions?.propertyType.toUpperCase());
      const userCredit = CREDIT_SCORES.get(aggregationData?.user_credit);
      const inputFromName = getInputFromName(selectedLoan);
      let appraisedValue = parseFloat(loanAssumption?.estimatedHomeValue) || 0;
      if (isFHAStreamlined(selectedLoan) || isStreamlinedOrIRRL(selectedLoan)) {
        appraisedValue = ficoInfo?.saleAmount || 0;
      }
      const ltvPerCard = calculateLTV(totalLoanAmount, appraisedValue);
      let OBBaseLoanAmount = totalLoanAmount;
      if (selectedLoan?.toLowerCase().includes('fha')) {
        const fhaBalance = Number(loanAssumption?.estimatedMortageBalance) || 0;
        const fhaInterest = closingCosts?.estimatedPrepaidExpenses?.interimInterestAmount ?? 0;
        const fhaMip = calculateMIPByCardType(selectedLoan, fhaBalance, fhaInterest);
        OBBaseLoanAmount = Math.round(totalLoanAmount - fhaMip);
      }
      const searchInput = new ProductSearchInput(
        occupancy,
        propertyType,
        numberOfUnits,
        aggregationData?.savedCounty,
        loanAssumption?.originalLoanVal,
        appraisedValue,
        userCredit,
        OBBaseLoanAmount,
        inputFromName.loanType,
        inputFromName.amortizationType,
        0,
        loanPurpose,
      );

      const { data: response, hasOBError } = await getRates(
        [searchInput],
        selectedLoan,
        aggregationData?.refiReason,
        [],
        closingCosts,
        userCredit,
        false,
        ltvPerCard,
        cardIndex,
      );

      const cardData = filterCard(response, selectedLoan, false, null, selectedRate, currentLoanAssumptions?.occupancyType, OBBaseLoanAmount);
      if (cardData?.selectedLoan) {
        if (cardIndex !== null) setCardError(cardIndex, undefined);
        return recalculateCashAtClosing(cardData, totalLoanAmount);
      }

      const emptyLoanCompare = new LoanCompare({}, {}, 0, 0, selectedLoan);
      emptyLoanCompare.loanToValue = ltvPerCard;
      if (cardIndex !== null) {
        if (emptyLoanCompare.error) {
          setCardError(cardIndex, 'The loan amount must be at least $10,000');
        } else if (!hasOBError) {
          setCardError(cardIndex, 'No rates returned. Please check your Loan to Value ratio.');
        }
      }
      return emptyLoanCompare;
    } catch (e) {
      console.error('getCardDataPerCard', e);

      const calculatedLTV = calculateLTV(totalLoanAmount, loanAssumption?.estimatedHomeValue);
      const emptyLoanCompare = new LoanCompare({}, {}, 0, 0, selectedLoan);
      emptyLoanCompare.loanToValue = calculatedLTV;
      return emptyLoanCompare;
    } finally {
      setIsObExecuting(false);
    }
  }, [currentLoanAssumptions, ficoInfo, getRates, recalculateCashAtClosing]);

  const getHelocCardDataPerCard = useCallback(async (selectedLoan, totalLoanAmount, onError) => {
    const userCredit = CREDIT_SCORES.get(aggregatedData?.user_credit);
    const ltv = calculateLTV(
      (currentLoanAssumptions?.estimatedMortageBalance ?? 0) + totalLoanAmount,
      currentLoanAssumptions?.estimatedHomeValue,
    );
    const loanAmount = (currentLoanAssumptions?.estimatedMortageBalance ?? 0) + totalLoanAmount;
    const rulesResult = determineHelocAmount(userCredit, ltv, totalLoanAmount, [selectedLoan], loanAmount, currentLoanAssumptions?.occupancyType);
    if (rulesResult[0] === 0) {
      onError?.('Based on the information provided, this loan is unavailable. This may be due to high Loan to Value or Jumbo loan restrictions. Try changing the total loan amount or call us at 800.460.2889 to discuss.');
      return new LoanCompare({}, {}, 0, 0, selectedLoan);
    }
    const result = await invokeHomeEquityRate(
      [selectedLoan],
      ltv,
      userCredit,
      currentLoanAssumptions,
      totalLoanAmount,
      aggregatedData?.refiReason,
      helocClosingCostsData?.fundsAtClosing?.closingCosts,
    );
    const cardData = result.data[0];
    if (cardData?.selectedLoan && cardData?.interestRate > 0) {
      return recalculateCashAtClosing(cardData, totalLoanAmount);
    }
    onError?.(result.message || 'No rates available. Please check your Loan to Value ratio.');
    return new LoanCompare({}, {}, 0, 0, selectedLoan);
  }, [aggregatedData, currentLoanAssumptions, helocClosingCostsData, recalculateCashAtClosing]);

  /**
  * Recalculates payment and other card data without calling Optimal Blue
  * Uses existing card data with new loan amount
  */
  const recalculateCardDataWithoutOB = useCallback((existingCardData, newLoanAmount, loanAssumptions, closingCosts) => {
    if (!existingCardData || !existingCardData.productId || !existingCardData.interestRate) return existingCardData;

    const usesSaleAmount = isFHAStreamlined(existingCardData?.selectedLoan) || isStreamlinedOrIRRL(existingCardData?.selectedLoan);
    const ltvAppraisedValue = usesSaleAmount ? (ficoInfo?.saleAmount || loanAssumptions?.estimatedHomeValue) : loanAssumptions?.estimatedHomeValue;
    const ltvPerCard = calculateLTV(newLoanAmount, ltvAppraisedValue);
    const newPrincipalAndInterest = getPrincipleInterest(
      existingCardData.interestRate / 100,
      existingCardData.termInMonths,
      newLoanAmount,
    );

    const ratePrice = existingCardData.price || 100;
    const discountRebateAmount = newLoanAmount * Math.abs((ratePrice - 100) / 100);
    const hasDiscount = ratePrice < 100;

    const updatedCardData = new LoanCompare(
      {
        rate: existingCardData.interestRate,
        apr: existingCardData.apr,
        productId: existingCardData.productId,
        principalAndInterest: newPrincipalAndInterest,
        discount: hasDiscount ? discountRebateAmount : 0,
        rebate: hasDiscount ? 0 : discountRebateAmount,
        price: existingCardData.price,
        selectedLoan: existingCardData.selectedLoan,
        productName: existingCardData.productName,
      },
      loanAssumptions,
      newLoanAmount,
      0,
      existingCardData.selectedLoan,
      ltvPerCard,
      '',
      closingCosts?.fundsAtClosing?.closingCosts ?? 0,
    );

    const result = recalculateCashAtClosing(updatedCardData, newLoanAmount);
    result.allRateOptions = existingCardData.allRateOptions;
    result.selectedRateIndex = existingCardData.selectedRateIndex;
    return result;
  }, [recalculateCashAtClosing, ficoInfo]);

  const updateRateOptions = (index, result) => {
    const { allRateOptions, selectedRateIndex } = result;
    const mapped = mapRateOptions(allRateOptions, selectedRateIndex);
    setRateOptions((prev) => {
      const newRateOptions = [...prev];
      newRateOptions[index] = mapped;
      return newRateOptions;
    });
  };

  useEffect(() => {
    if (clientError) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [clientError]);

  const applyCardSelection = (selectedLoan, cardData, totalLoanAmount, selectedRate, setCardData, rateIndex, setCardLoading) => {
    if (!acceptedLoanAssumption || !selectedLoan) return;

    setCardError(rateIndex, undefined);

    if (isHomeEquity(selectedLoan)) {
      if (totalLoanAmount === 0) {
        setCardData(new LoanCompare({}, currentLoanAssumptions, 0, 0, selectedLoan));
        return;
      }
      setCardLoading?.(true);
      getHelocCardDataPerCard(selectedLoan, totalLoanAmount, (msg) => setCardError(rateIndex, msg))
        .then((result) => {
          setCardData(result);
        })
        .finally(() => setCardLoading?.(false));
      return;
    }
    const cached = filterCard(allCardsData, selectedLoan, false, cardData, selectedRate, currentLoanAssumptions?.occupancyType, initialTotalLoanAmount);
    if (cached?.selectedLoan) {
      setCardData(recalculateCardDataWithoutOB(cached, totalLoanAmount, currentLoanAssumptions, refiClosingCostsData));
      if (cached?.allRateOptions?.length) updateRateOptions(rateIndex, cached);
    } else {
      const cashAtClosing = previewCashAtClosingForAmount(cardData, selectedLoan, totalLoanAmount);
      const isCashOut = autoRecalculate[rateIndex]?.buttonType !== 'onePayment'
        && autoRecalculate[rateIndex]?.buttonType !== 'minCash'
        && cashAtClosing > 0;
      setCardLoading?.(true);
      getCardDataPerCard(selectedLoan, totalLoanAmount, isCashOut, aggregatedData, currentLoanAssumptions, refiClosingCostsData, selectedRate, rateIndex)
        .then((result) => {
          setCardData(result);
          updateRateOptions(rateIndex, result);
        })
        .finally(() => setCardLoading?.(false));
    }
  };

  // when removing a card, we want to shift remaining cards to the left to fill the gap and hide the last card.
  const handleRemoveCard = (cardIndex) => {
    if (cardIndex === 2) {
      setCardThreeVisible(false);
      setSelectedCardThree('');
      setCardThreeData(new LoanCompare());
      setTotalLoanAmountCardThree(initialTotalLoanAmount);
      setSelectedRateCardThree(null);
      if (selectedCardId === 'card3') setSelectedCardId('card1');
    } else if (cardIndex === 1) {
      if (cardThreeVisible) {
        // 3 cards: shift card3 to card2, hide card3
        setSelectedCardTwo(selectedCardThree);
        setCardTwoData(cardThreeData);
        setTotalLoanAmountCardTwo(totalLoanAmountCardThree);
        setSelectedRateCardTwo(selectedRateCardThree);
        setCardThreeVisible(false);
        setSelectedCardThree('');
        setCardThreeData(new LoanCompare());
        setTotalLoanAmountCardThree(initialTotalLoanAmount);
        setSelectedRateCardThree(null);
        if (selectedCardId === 'card3') setSelectedCardId('card1');
      } else {
        // 2 cards: just hide card2
        setCardTwoVisible(false);
        setSelectedCardTwo('');
        setCardTwoData(new LoanCompare());
        setTotalLoanAmountCardTwo(initialTotalLoanAmount);
        setSelectedRateCardTwo(null);
        if (selectedCardId === 'card2') setSelectedCardId('card1');
      }
    } else if (cardIndex === 0) {
      if (cardThreeVisible) {
        // 3 cards: shift card2 to card1, card3 to card2, hide card3
        setSelectedCardOne(selectedCardTwo);
        setCardOneData(cardTwoData);
        setTotalLoanAmountCardOne(totalLoanAmountCardTwo);
        setSelectedRateCardOne(selectedRateCardTwo);
        setSelectedCardTwo(selectedCardThree);
        setCardTwoData(cardThreeData);
        setTotalLoanAmountCardTwo(totalLoanAmountCardThree);
        setSelectedRateCardTwo(selectedRateCardThree);
        setCardThreeVisible(false);
        setSelectedCardThree('');
        setCardThreeData(new LoanCompare());
        setTotalLoanAmountCardThree(initialTotalLoanAmount);
        setSelectedRateCardThree(null);
        if (selectedCardId === 'card3') setSelectedCardId('card1');
      } else {
        // 2 cards: shift card2 to card1, hide card2
        setSelectedCardOne(selectedCardTwo);
        setCardOneData(cardTwoData);
        setTotalLoanAmountCardOne(totalLoanAmountCardTwo);
        setSelectedRateCardOne(selectedRateCardTwo);
        setCardTwoVisible(false);
        setSelectedCardTwo('');
        setCardTwoData(new LoanCompare());
        setTotalLoanAmountCardTwo(initialTotalLoanAmount);
        setSelectedRateCardTwo(null);
        if (selectedCardId === 'card2') setSelectedCardId('card1');
      }
    }
    setNewCardIndex(null);
  };

  const handleAddCard = () => {
    if (!cardTwoVisible) {
      setCardTwoVisible(true);
      setNewCardIndex(1);
    } else if (!cardThreeVisible) {
      setCardThreeVisible(true);
      setNewCardIndex(2);
    }
  };

  const handleCardChange = (cardIndex, selectedLoan) => {
    const selectedCards = [selectedCardOne, selectedCardTwo, selectedCardThree];
    const totalAmounts = [totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree];
    const setSelectedCards = [setSelectedCardOne, setSelectedCardTwo, setSelectedCardThree];
    const setRateChanges = [setCardOneRateChanged, setCardTwoRateChanged, setCardThreeRateChanged];
    const setTotalAmounts = [setTotalLoanAmountCardOne, setTotalLoanAmountCardTwo, setTotalLoanAmountCardThree];
    const setSelectedRates = [setSelectedRateCardOne, setSelectedRateCardTwo, setSelectedRateCardThree];
    const cardDatas = [cardOneData, cardTwoData, cardThreeData];
    const setCardDatas = [setCardOneData, setCardTwoData, setCardThreeData];
    const setLoadings = [setIsCardOneLoading, setIsCardTwoLoading, setIsCardThreeLoading];

    setNewCardIndex(null);
    setSelectedCards[cardIndex](selectedLoan);
    setRateChanges[cardIndex](false);
    setCardError(cardIndex, undefined);

    let amount = totalAmounts[cardIndex];
    if (isHomeEquity(selectedLoan)) {
      setTotalAmounts[cardIndex](0);
      amount = 0;
      setCardDatas[cardIndex](new LoanCompare({}, currentLoanAssumptions, 0, 0, selectedLoan));
    } else if (isFHAStreamlined(selectedLoan)) {
      setTotalAmounts[cardIndex](fhaStreamlinedAmount);
      amount = fhaStreamlinedAmount;
      setSelectedRates[cardIndex](null);
    } else if (isHomeEquity(selectedCards[cardIndex])) {
      setTotalAmounts[cardIndex](initialTotalLoanAmount);
      amount = initialTotalLoanAmount;
      setSelectedRates[cardIndex](null);
    } else {
      setSelectedRates[cardIndex](null);
      if (cardErrors[cardIndex]) {
        setTotalAmounts[cardIndex](initialTotalLoanAmount);
        amount = initialTotalLoanAmount;
      }
    }
    applyCardSelection(selectedLoan, cardDatas[cardIndex], amount, null, setCardDatas[cardIndex], cardIndex, setLoadings[cardIndex]);
  };

  useEffect(() => {
    if (cardOneRateChanged) return;
    if (cardOneData?.selectedLoan?.toLowerCase() !== selectedCardOne?.toLowerCase()) {
      applyCardSelection(selectedCardOne, cardOneData, totalLoanAmountCardOne, selectedRateCardOne, setCardOneData, 0, setIsCardOneLoading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCardOne]);

  useEffect(() => {
    if (cardTwoRateChanged) return;
    if (cardTwoData?.selectedLoan?.toLowerCase() !== selectedCardTwo?.toLowerCase()) {
      applyCardSelection(selectedCardTwo, cardTwoData, totalLoanAmountCardTwo, selectedRateCardTwo, setCardTwoData, 1, setIsCardTwoLoading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCardTwo]);

  useEffect(() => {
    if (cardThreeRateChanged) return;
    if (cardThreeData?.selectedLoan?.toLowerCase() !== selectedCardThree?.toLowerCase()) {
      applyCardSelection(selectedCardThree, cardThreeData, totalLoanAmountCardThree, selectedRateCardThree, setCardThreeData, 2, setIsCardThreeLoading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCardThree]);

  const handlePropertyInfoShowOptions = () => {
    setShouldShowPropertyModal(false);
    setIsLoanAssumptionModalOpen(false);
    setAcceptedLoanAssumption(true);
  };

  const handlePropertyInfoAdjustLoanAssumption = () => {
    setIsLoanAssumptionModalOpen(true);
  };

  const handlePropertyInfoModalClose = () => {
    setShouldShowPropertyModal(false);
  };

  const handleCurrentLoanAssumptionModalSave = async (updatedLoanAssumptions) => {
    setAcceptedLoanAssumption(true);
    setIsLoanAssumptionModalOpen(false);
    setShouldShowPropertyModal(false);

    const currentMortgageAmount = calculateTotalCurrentMortgageAmount(updatedLoanAssumptions);
    const cashReq = (cashOutResults?.cashReq || 0);
    const cashMort = cashReq + currentMortgageAmount;
    const estHomeVal = parseFloat(updatedLoanAssumptions.estimatedHomeValue) || 0;
    const ltv = estHomeVal > 0 ? parseFloat(((cashMort / estHomeVal) * 100).toFixed(2)) : 0;
    const cashOut = new CashOut(cashReq, estHomeVal, cashMort, ltv, currentMortgageAmount);
    const updatedPropertyInfo = PropertyInfo.setPropertyInfo(updatedLoanAssumptions);
    setCurrentLoanAssumptions(updatedLoanAssumptions);
    setCashOutResults(cashOut);
    setPropertyInfo(updatedPropertyInfo);
    setCashOutResults((prev) => ({ ...prev, refiReason: aggregatedData?.refiReason }));
  };

  const handleCurrentLoanAssumptionModalClose = () => {
    setIsLoanAssumptionModalOpen(false);
  };

  const showSaveProposalModalFromHaveLoanOfficer = () => {
    setSaveProposalResults((prev) => ({
      ...prev,
      selectedLoanOfficerToContact: 'Yes',
    }));
    setIsSaveProposalModalOpen(true);
  };

  const showSaveProposalModalFromSaveForLater = () => {
    setSaveProposalResults((prev) => ({
      ...prev,
      selectedLoanOfficerToContact: isProspect ? haveLoanOfficerContactMeFlag.current : 'Not Now',
    }));
    setIsSaveProposalModalOpen(true);
  };

  const closeSaveProposalModal = () => {
    setIsSaveProposalModalOpen(false);
  };

  const handleSaveProposalSubmit = async (value) => {
    setSaveProposalResults(value);
    setPendingSave(true);
    setShouldCallValueCheck(false);
  };

  const handleLoanAssumptionsNewPayment = () => {
    setIsLoanAssumptionModalOpen(true);
  };

  useEffect(() => {
    if (acceptedLoanAssumption && reasonRef.current) {
      window.scrollTo({
        top: reasonRef.current.offsetTop + 250,
        behavior: 'smooth',
      });
    }
    // focusOnCashOut(aggregatedData?.refiReason);
  }, [acceptedLoanAssumption]);

  const clearPage = () => {
    setCurrentLoanAssumptions(new LoanAssumptions());
    setPropertyInfo(new PropertyInfo());
    setCashOutResults(new CashOut());
    setFicoInfo(new FicoInfo());
    setAcceptedLoanAssumption(false);
    setHasReason(false);
    // setSaveProposalResults(new ContactInformation());
    setPendingSave(null);
    setSelectedLoanType('REFI');
    setSelectedCardOne('');
    setSelectedCardTwo('');
    setSelectedCardThree('');
    setAllCardsData([]);
    setCardOneData(new LoanCompare());
    setCardTwoData(new LoanCompare());
    setCardThreeData(new LoanCompare());
    setCardTwoVisible(true);
    setCardThreeVisible(true);
    setInitialTotalLoanAmount(0);
    setTotalLoanAmountCardOne(0);
    setTotalLoanAmountCardTwo(0);
    setTotalLoanAmountCardThree(0);
    setSelectedRateCardOne(null);
    setSelectedRateCardTwo(null);
    setSelectedRateCardThree(null);
    setCardOneRateChanged(false);
    setCardTwoRateChanged(false);
    setCardThreeRateChanged(false);
    setSelectedCardId('card1');
    setRateDate('...');
    hasShownPropertyModal.current = false;
    clearAllCardErrors();
    setIsObExecuting(false);
    setAllCardsLoading(false);
    setHelocClosingCostsData(new ClosingCosts());
    setRefiClosingCostsData(new ClosingCosts());
    setSessionStorageItem(propertyInfoModalSessionStorageKey, 'true');
  };

  const handlePropertyIdentifier = (id, propertyCounty, propertyAddress) => {
    // This handler will reboot the entire workflow, that's why it's clearing the page.
    if (prospect && isFirstTimeOnSavedURLForReasonChange.current) {
      isFirstTimeOnSavedURLForReasonChange.current = false;
    }
    clearPage();
    setPropertyIdentifier(id);
    setAggregatedData((prev) => ({
      ...prev,
      savedCounty: propertyCounty,
      savedAddress: propertyAddress,
    }));
    setShouldCallValueCheck(true);
  };

  const propertyDetails = async (propertyId) => {
    const results = await getPropertyDetails(propertyId);

    if (results?.data === null || results === 500) {
      clearPage();
      return;
    }

    const isSecondLoanOnly = hasSecondLoanOnly(results?.data?.loans);

    const loanTermTmp = results?.data?.loans?.[0]?.term !== undefined ? (results?.data?.loans?.[0]?.term ?? 0) * 12 : 0;
    const propertyType = results?.data?.characteristics?.propertyType || '';
    const isErrorType = ERROR_PROPERTY_TYPES.some((index) => propertyType.toUpperCase().includes(index));

    if (isErrorType) {
      setShowPropertyTypeModalError(true); // trigger the property type error modal
      setIsObExecuting(false);
      return;
    }

    setAggregatedData((prev) => ({
      ...prev,
      currLoanTerm: isSecondLoanOnly ? 0 : loanTermTmp?.toString(),
      currDueDate: isSecondLoanOnly ? null : results?.data?.loans?.[0]?.dueDate,
    }));

    const updatedFicoInfo = FicoInfo.setFromValueCheck(results?.data);
    const tempAssumptions = LoanAssumptions.setFromValueCheck(results?.data, updatedFicoInfo);
    const cashOut = CashOut.setFromValueCheck(tempAssumptions, aggregatedData?.refiReason);
    cashOut.currentMortgageAmount = tempAssumptions.estimatedMortageBalance;
    cashOut.refiReason = aggregatedData?.refiReason;
    setCurrentLoanAssumptions(tempAssumptions);
    setPropertyInfo(PropertyInfo.setPropertyInfo(tempAssumptions));
    setCashOutResults(cashOut);
    setFicoInfo(updatedFicoInfo);
    localStorage.removeItem('rateDate');
    localStorage.removeItem(`totalLoanAmounts_${getApplicantSecureId() || 'new'}`);
    initializedRef.current = false;
    return results;
  };

  const fetchLoanOfficers = async () => {
    const response = await getLoanOfficers();
    const officers = response?.data?.officers || [];
    let officersList = [...officers.map((officer) => ({ key: officer.id, value: `${officer.first_name} ${officer.last_name}` }))];

    if (!prospect) {
      officersList = [{ key: null, value: 'No Preference' }, ...officersList];
    } else if (prospect && !selectedLODetails?.is_contactable) {
      officersList = [...officersList, { key: selectedLODetails.id, value: `${selectedLODetails.first_name} ${selectedLODetails.last_name}` }];
    }

    setLoanOfficers(officersList);
  };

  const fetchSelectedLoanOfficer = async (loanOfficerId) => {
    const response = await getSelectedLO(loanOfficerId);
    if (response?.status === 200) {
      setSelectedLODetails(response.data.officer);
    }
  };

  useEffect(() => {
    if (propertyIdentifier > 0 && shouldCallValueCheck) {
      propertyDetails(propertyIdentifier);
      fetchLoanOfficers();
    }
    // eslint-disable-next-line
  }, [propertyIdentifier, shouldCallValueCheck]);

  const moreInfoDataPoints = useMemo(() => {
    if (
      cardOneData === undefined
      || cardTwoData === undefined
      || cardThreeData === undefined
    ) return null;

    const getCardClosingCosts = (selectedLoan) => (isHomeEquity(selectedLoan) ? helocClosingCostsData : refiClosingCostsData);
    const cardOneCC = getCardClosingCosts(selectedCardOne);
    const cardTwoCC = getCardClosingCosts(selectedCardTwo);
    const cardThreeCC = getCardClosingCosts(selectedCardThree);

    if (!cardOneCC?.fundsAtClosing && !cardTwoCC?.fundsAtClosing && !cardThreeCC?.fundsAtClosing) return null;

    const totalLoanAmounts = [totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree];

    const cardMap = {
      card1: recalculateCardDataWithoutOB(cardOneData, totalLoanAmountCardOne, currentLoanAssumptions, cardOneCC),
      card2: recalculateCardDataWithoutOB(cardTwoData, totalLoanAmountCardTwo, currentLoanAssumptions, cardTwoCC),
      card3: recalculateCardDataWithoutOB(cardThreeData, totalLoanAmountCardThree, currentLoanAssumptions, cardThreeCC),
    };

    return {
      card1: buildMoreInfoDataPoints({
        closingCostsData: cardOneCC,
        selectedCardId: 'card1',
        cardMap,
        totalLoanAmounts,
        cardName: selectedCardOne,
        loanAssumptions: currentLoanAssumptions,
        ficoInfo,
      }),
      card2: buildMoreInfoDataPoints({
        closingCostsData: cardTwoCC,
        selectedCardId: 'card2',
        cardMap,
        totalLoanAmounts,
        cardName: selectedCardTwo,
        loanAssumptions: currentLoanAssumptions,
        ficoInfo,
      }),
      card3: buildMoreInfoDataPoints({
        closingCostsData: cardThreeCC,
        selectedCardId: 'card3',
        cardMap,
        totalLoanAmounts,
        cardName: selectedCardThree,
        loanAssumptions: currentLoanAssumptions,
        ficoInfo,
      }),
    };
  }, [
    helocClosingCostsData,
    refiClosingCostsData,
    cardOneData,
    cardTwoData,
    cardThreeData,
    selectedCardOne,
    selectedCardTwo,
    selectedCardThree,
    totalLoanAmountCardOne,
    totalLoanAmountCardTwo,
    totalLoanAmountCardThree,
    currentLoanAssumptions,
    ficoInfo,
    recalculateCardDataWithoutOB,
  ]);

  useEffect(() => {
    if (prospect) {
      setIsProspect(true);
      const applicationData = prospect?.application_data;
      const lastUpdatedApp = prospect?.last_updated_app;
      if (lastUpdatedApp === 'refi-ui' && !isValidApplicationData(applicationData) && !applicationData?.shouldCallValueCheck) {
        return;
      }

      fetchLoanOfficers();
      fetchSelectedLoanOfficer(prospect.loan_officer_id);

      const loanAssumption = new LoanAssumptions(applicationData);
      setCurrentLoanAssumptions(loanAssumption);

      const propertyInfos = PropertyInfo.setFromDB(applicationData.estimatedHomeValue, applicationData.mortgages);
      setPropertyInfo(propertyInfos);

      const currentMort = calculateTotalCurrentMortgageAmount(applicationData);
      const cashMort = applicationData.cashRequest + currentMort;
      const estHomeVal = parseFloat(applicationData.estimatedHomeValue) || 0;
      const ltv = estHomeVal > 0 ? parseFloat(((cashMort / estHomeVal) * 100).toFixed(2)) : 0;

      setCashOutResults(new CashOut(applicationData.cashRequest, estHomeVal, cashMort, ltv, currentMort));
      setSaveProposalResults(ContactInformation.fromProspect(prospect));
      haveLoanOfficerContactMeFlag.current = prospect?.application_data?.confirmLoanOfficerToContact || 'Not Now';
      setAggregatedData(new AggregatedData({
        savedCounty: applicationData.county,
        savedAddress: applicationData.address,
        currLoanTerm: applicationData.loanTerm,
        currDueDate: applicationData.dueDate,
        user_credit: applicationData.user_credit,
        refiReason: applicationData.primary_reason,
      }));

      setFicoInfo((prev) => new FicoInfo({
        ...prev,
        saleAmount: applicationData.salePrice,
        saleDate: applicationData.salesDate,
        loanType: applicationData.loanType,
        docDate: applicationData.docDate,
      }));

      setSelectedRateCardOne(applicationData?.loanCards?.[0]?.selectedRate || '');
      setSelectedRateCardTwo(applicationData?.loanCards?.[1]?.selectedRate || '');
      setSelectedRateCardThree(applicationData?.loanCards?.[2]?.selectedRate || '');

      setSelectedCardOne(applicationData?.loanCards?.[0]?.loanType || '');
      setSelectedCardTwo(applicationData?.loanCards?.[1]?.loanType || '');
      setSelectedCardThree(applicationData?.loanCards?.[2]?.loanType || '');
      if (applicationData?.loanCards?.length) {
        setCardTwoVisible(!!(applicationData?.loanCards?.[1]?.loanType));
        setCardThreeVisible(!!(applicationData?.loanCards?.[2]?.loanType));
        setCardOneData(new LoanCompare({}, {}, 0, 0, applicationData?.loanCards?.[0]?.loanType || ''));
        setCardTwoData(new LoanCompare({}, {}, 0, 0, applicationData?.loanCards?.[1]?.loanType || ''));
        setCardThreeData(new LoanCompare({}, {}, 0, 0, applicationData?.loanCards?.[2]?.loanType || ''));
      }

      const savedTotalLoanAmountCardOne = applicationData?.loanCards?.[0]?.totalLoanAmount;
      const savedTotalLoanAmountCardTwo = applicationData?.loanCards?.[1]?.totalLoanAmount;
      const savedTotalLoanAmountCardThree = applicationData?.loanCards?.[2]?.totalLoanAmount;
      const hasAnySavedAmount = savedTotalLoanAmountCardOne != null
        || savedTotalLoanAmountCardTwo != null
        || savedTotalLoanAmountCardThree != null;
      if (hasAnySavedAmount) {
        if (savedTotalLoanAmountCardOne != null) {
          setTotalLoanAmountCardOne(savedTotalLoanAmountCardOne);
        }
        if (savedTotalLoanAmountCardTwo != null) {
          setTotalLoanAmountCardTwo(savedTotalLoanAmountCardTwo);
        }
        if (savedTotalLoanAmountCardThree != null) {
          setTotalLoanAmountCardThree(savedTotalLoanAmountCardThree);
        }
        initializedRef.current = true;
      }

      setSelectedCardId(applicationData?.selectedCardId || 'card1');
      setPropertyIdentifier(applicationData.property_id);
      if (getSessionStorageItem(propertyInfoModalSessionStorageKey) === 'false') {
        setAcceptedLoanAssumption(true);
      } else {
        setShouldShowPropertyModal(true);
      }

      if (searchParams.has('showContactInformation')) {
        setIsSaveProposalModalOpen(true);
      }

      setShouldCallValueCheck(applicationData?.shouldCallValueCheck);
    }
    // eslint-disable-next-line
  }, [prospect]);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (cashOutResults?.estHomeVal && currentLoanAssumptions?.estimatedHomeValue != cashOutResults?.estHomeVal) {
      const propertyInsurance = getPropertyInsurance(parseFloat(cashOutResults?.estHomeVal), currentLoanAssumptions?.propertyType);
      const monthlyPayment = Math.round((parseFloat(currentLoanAssumptions?.estimatedPrincipalAndInterest)))
        + Math.round((parseFloat(currentLoanAssumptions?.estimatedTaxes)))
        + Math.round((parseFloat(propertyInsurance)))
        + Math.round((parseFloat(currentLoanAssumptions?.estimatedFloodInsurance)))
        + Math.round((parseFloat(currentLoanAssumptions?.estimatedMortgageInsurance)));

      setCurrentLoanAssumptions((prev) => ({
        ...prev,
        estimatedHomeValue: cashOutResults.estHomeVal,
        estimatedPropertyInsurance: propertyInsurance,
        estimatedMonthlyPayment: monthlyPayment,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashOutResults?.estHomeVal]);

  useEffect(() => {
    if (currentLoanAssumptions?.estimatedHomeValue
      && !Number.isNaN(currentLoanAssumptions?.estimatedHomeValue)
      && currentLoanAssumptions?.estimatedHomeValue !== cashOutResults?.estHomeVal) {
      setCashOutResults((prev) => ({
        ...prev,
        estHomeVal: currentLoanAssumptions.estimatedHomeValue,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLoanAssumptions?.estimatedHomeValue]);

  useEffect(() => {
    // Ensure all required data is available before calculating closing costs
    if (acceptedLoanAssumption && cashOutResults?.cashReq != null && currentLoanAssumptions?.estimatedHomeValue && currentLoanAssumptions?.propertyType) {
      try {
        if (ficoInfo?.loanType === null && cashOutResults?.cashReq === 0) {
          // clear all OB cards.
          const selectedCards = [selectedCardOne, selectedCardTwo, selectedCardThree];
          const noLoanCards = [];
          selectedCards.forEach((card) => {
            if (!isHomeEquity(card)) {
              noLoanCards.push(new LoanCompare({}, {}, 0, 0, card));
            }
          });
          const helocClosingCosts = helocClosingCostsMapping(cashOutResults);
          setHelocClosingCostsData(helocClosingCosts);
          setRefiClosingCostsData(new ClosingCosts());
          setAllCardsData((prev) => prev.concat(noLoanCards));
          return;
        }
        const helocClosingCosts = helocClosingCostsMapping(cashOutResults);
        setHelocClosingCostsData(helocClosingCosts);
        const refiClosingCosts = refiClosingCostsMapping(cashOutResults, currentLoanAssumptions, ficoInfo);
        setRefiClosingCostsData(refiClosingCosts);
        setInitialTotalLoanAmount(getLoanTotalAmount(
          Number(currentLoanAssumptions?.estimatedMortageBalance),
          refiClosingCosts.fundsAtClosing.secondLoan,
          refiClosingCosts.fundsAtClosing.closingCosts,
          Number(refiClosingCosts.fundsAtClosing.prepaidExpenses),
          Number(currentLoanAssumptions?.estimatedMonthlyPayment),
        ));
      } catch (e) {
        console.error('Error in refiClosingCostsMapping:', e);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    acceptedLoanAssumption,
    cashOutResults?.cashReq,
    currentLoanAssumptions?.includeSecondLoan,
    currentLoanAssumptions?.estimatedMonthlyPayment,
    currentLoanAssumptions?.estimatedMortageBalance,
    currentLoanAssumptions?.estimatedSecondMortgageBalance,
  ]);

  // get 3 default cards: selectedCards
  useEffect(() => {
    const normalizedList = normalizeList(REASONS_FOR_REFINANCE);
    // trigger default cards when no prospect is created, if saved prospect does not have saved cards, or if saved prospect has cards but user changes loanType or reason for refinance
    const shouldTriggerDefaultCards = !prospect || !prospect?.application_data?.loanCards || (prospect?.application_data?.loanCards && !isFirstTimeOnSavedURLForReasonChange.current);

    if (shouldTriggerDefaultCards) {
      const cards = getDefaultCards(normalizedList, aggregatedData?.refiReason, ficoInfo?.loanType);
      setSelectedCardOne(cards[0]);
      setSelectedCardTwo(cards[1]);
      setSelectedCardThree(cards[2]);
      setCardOneData(new LoanCompare({}, {}, 0, 0, cards[0]));
      setCardTwoData(new LoanCompare({}, {}, 0, 0, cards[1]));
      setCardThreeData(new LoanCompare({}, {}, 0, 0, cards[2]));
      setLoanCompareSectionShowMore(false);
      setSelectedCardId('card1');
      setSelectedLoanType(isHomeEquity(cards[0]) ? cards[0] : 'REFI');
      if (acceptedLoanAssumption && initialTotalLoanAmount > 0) {
        const getDefaultCardAmount = (cardName) => {
          switch (true) {
            case isHomeEquity(cardName):
              return 0;
            case isFHAStreamlined(cardName):
              return fhaStreamlinedAmount;
            default:
              return initialTotalLoanAmount;
          }
        };
        const newCardOneLoanAmount = getDefaultCardAmount(cards[0]);
        const newCardTwoLoanAmount = getDefaultCardAmount(cards[1]);
        const newCardThreeLoanAmount = getDefaultCardAmount(cards[2]);
        // Update ref synchronously so per-card async HELOC API callbacks discard stale results
        heAmountsRef.current = [newCardOneLoanAmount, newCardTwoLoanAmount, newCardThreeLoanAmount];
        setTotalLoanAmountCardOne(newCardOneLoanAmount);
        setTotalLoanAmountCardTwo(newCardTwoLoanAmount);
        setTotalLoanAmountCardThree(newCardThreeLoanAmount);
      }
    }

    if (acceptedLoanAssumption === true && allCardsData.length > 0) {
      const highlight = getHighlightedOption(aggregatedData?.refiReason);
      setAllCardsData((prev) => prev.map((card) => ({
        ...card,
        highlight,
      })));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aggregatedData?.refiReason, ficoInfo?.loanType]);

  // Apply FHA Streamlined loan amount override once initialTotalLoanAmount is available.
  useEffect(() => {
    if (!acceptedLoanAssumption || initialTotalLoanAmount <= 0) return;
    const cards = [selectedCardOne, selectedCardTwo, selectedCardThree];
    const setters = [setTotalLoanAmountCardOne, setTotalLoanAmountCardTwo, setTotalLoanAmountCardThree];
    cards.forEach((card, i) => {
      if (isFHAStreamlined(card)) {
        heAmountsRef.current[i] = fhaStreamlinedAmount;
        setters[i](fhaStreamlinedAmount);
      }
    });
  }, [initialTotalLoanAmount, selectedCardOne, selectedCardTwo, selectedCardThree, fhaStreamlinedAmount, acceptedLoanAssumption]);

  // CALL OB, FORCED
  useEffect(() => {
    const hasNonHeCard = [selectedCardOne, selectedCardTwo, selectedCardThree].some((c) => !isHomeEquity(c));
    if (!Number.isNaN(refiClosingCostsData?.fundsAtClosing?.calculatedLoanAmount)
      && acceptedLoanAssumption === true
      && hasNonHeCard
    ) {
      if (!isObExecuting) {
        getInitialCardsData(aggregatedData, currentLoanAssumptions);
      }
    }

    if (ficoInfo?.loanType === null) {
      const selectedCards = [selectedCardOne, selectedCardTwo, selectedCardThree];
      const noLoanCards = [];
      selectedCards.forEach((card) => {
        if (!isHomeEquity(card)) {
          noLoanCards.push(new LoanCompare({}, {}, 0, 0, card));
        }
      });
      setAllCardsData(noLoanCards);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    acceptedLoanAssumption,
    refiClosingCostsData?.fundsAtClosing?.calculatedLoanAmount,
    aggregatedData?.user_credit,
    currentLoanAssumptions?.occupancyType,
    currentLoanAssumptions?.propertyType]);

  // RECALCULATE CARDS
  useEffect(() => {
    if (allCardsData.length > 0) {
      setAllCardsData((prev) => prev.map((card, index) => {
        // skip empty cards
        if (!card.interestRate || card.interestRate === 0) return card;
        const data = {
          rate: card.interestRate,
          apr: card.apr,
          principalAndInterest: card.newPrincipalAndInterest,
          productId: card.productId,
        };

        if (isHomeEquity(card.selectedLoan)) {
          const newLoanCard = new LoanCompare(
            data,
            currentLoanAssumptions,
            cashOutResults?.cashReq,
            cashOutResults?.cashReq,
            card.selectedLoan,
            cashOutResults?.ltv,
            aggregatedData?.refiReason,
          );
          if (newLoanCard.error) {
            setCardError(index, 'The loan amount must be at least $10,000');
          } else {
            return newLoanCard;
          }
        }
        return new LoanCompare(
          data,
          currentLoanAssumptions,
          refiClosingCostsData?.fundsAtClosing?.calculatedLoanAmount,
          refiClosingCostsData?.fundsAtClosing?.initialDrawFromLoan,
          card.selectedLoan,
          cashOutResults?.ltv,
          aggregatedData?.refiReason,
          refiClosingCostsData?.fundsAtClosing?.closingCosts,
          refiClosingCostsData?.fundsAtClosing,
        );
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentLoanAssumptions?.estimatedFloodInsurance,
    currentLoanAssumptions?.estimatedMortgageInsurance,
    currentLoanAssumptions?.estimatedMonthlyPayment,
  ]);

  // CLEAR DATE
  useEffect(() => {
    if (!hasReason && localStorage.getItem('rateDate')) {
      localStorage.removeItem('rateDate');
    }
  }, [hasReason]);

  useEffect(() => {
    // logic for calling the heloc rules matrix
    // const allCards = [cardOneData, cardTwoData, cardThreeData];
    // const keyWords = ['HELOC', 'HELOAN'];

    // const rulesPassed = [];
    // allCards.forEach((card, index) => {
    //   const loanType = card.selectedLoan.toUpperCase();
    //   if (keyWords.includes(loanType)) {
    //     const loanAmount = cashOutResults.cashReq + currentLoanAssumptions.estimatedMortageBalance;
    //     const HEAttempt = applyHomeEquityRules(cashOutResults.ltv, cashOutResults.cashReq, ficoInfo.fico, card.selectedLoan, loanAmount, currentLoanAssumptions.occupancyType);
    //     rulesPassed[index] = HEAttempt;
    //   }
    // });
    // if (rulesPassed.includes(false)) {
    //   setHelocWarning(true);
    // } else {
    //   setHelocWarning(false);
    // }

    if (pendingSave) {
      const loanCardOne = {
        productId: cardOneData?.productId,
        loanType: cardOneData?.selectedLoan,
        card: 1,
        selectedRate: cardOneData?.interestRate,
        totalLoanAmount: totalLoanAmountCardOne,
        cashOutRefi: (cardOneData?.cashAtClosing ?? 0) > 0 ? 'Yes' : 'No',
      };
      const loanCardTwo = {
        productId: cardTwoData?.productId,
        loanType: cardTwoData?.selectedLoan,
        card: 2,
        selectedRate: cardTwoData?.interestRate,
        totalLoanAmount: totalLoanAmountCardTwo,
        cashOutRefi: (cardTwoData?.cashAtClosing ?? 0) > 0 ? 'Yes' : 'No',
      };
      const loanCardThree = {
        productId: cardThreeData?.productId,
        loanType: cardThreeData?.selectedLoan,
        card: 3,
        selectedRate: cardThreeData?.interestRate,
        totalLoanAmount: totalLoanAmountCardThree,
        cashOutRefi: (cardThreeData?.cashAtClosing ?? 0) > 0 ? 'Yes' : 'No',
      };
      const loanCards = [loanCardOne, loanCardTwo, loanCardThree];

      const loanInfo = new LoanInfo(
        propertyIdentifier,
        currentLoanAssumptions,
        cashOutResults,
        aggregatedData,
        saveProposalResults,
        propertyInfo,
        ficoInfo,
        loanCards,
        selectedCardId,
        shouldCallValueCheck,
      );
      const executeSave = async () => {
        const applicationSecureId = getApplicantSecureId();
        const saveResults = await updateApplicant(applicationSecureId, loanInfo);
        if (saveResults.status === 201 || saveResults.status === 200) {
          setSessionStorageItem(propertyInfoModalSessionStorageKey, 'false');
          setIsSaveProposalModalOpen(false);
          haveLoanOfficerContactMeFlag.current = saveResults?.data?.prospect?.application_data?.confirmLoanOfficerToContact;
          setProspect(saveResults?.data?.prospect);
          // On new prospect creation, generate personalized URL and trigger email modal
          if (applicationSecureId === null) {
            const secureId = saveResults?.data?.applicantSecureId;
            if (secureId) {
              const base = window.location.href.split('#')[0].replace(/\/$/, '');
              const newUrl = `${base}/#/${secureId}`;
              setNewApplicantURL(newUrl);
              setEmailSentModal(true);
            } else {
              setApiPostError(true);
            }
          }
        } else {
          setApiPostError(true);
        }
        setPendingSave(false);
      };
      executeSave();
    }
  }, [
    currentLoanAssumptions,
    cashOutResults,
    aggregatedData,
    saveProposalResults,
    propertyInfo,
    pendingSave,
    propertyIdentifier,
    ficoInfo,
    cardOneData,
    cardTwoData,
    cardThreeData,
    selectedCardId,
    shouldCallValueCheck,
    totalLoanAmountCardOne,
    totalLoanAmountCardTwo,
    totalLoanAmountCardThree,
  ]);

  useEffect(() => {
    heAmountsRef.current = [totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree];
  }, [totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree]);

  useEffect(() => {
    if (!acceptedLoanAssumption) return;
    const cards = [
      {
        loan: selectedCardOne,
        amount: totalLoanAmountCardOne,
        setter: setCardOneData,
        index: 0,
      },
      {
        loan: selectedCardTwo,
        amount: totalLoanAmountCardTwo,
        setter: setCardTwoData,
        index: 1,
      },
      {
        loan: selectedCardThree,
        amount: totalLoanAmountCardThree,
        setter: setCardThreeData,
        index: 2,
      },
    ];
    cards.forEach(({
      loan, amount, setter, index,
    }) => {
      if (!isHomeEquity(loan)) return;
      if (amount === 0) {
        setter(new LoanCompare({}, {}, 0, 0, loan));
        return;
      }
      setCardError(index, undefined);
      getHelocCardDataPerCard(loan, amount, (msg) => setCardError(index, msg)).then((result) => {
        if (heAmountsRef.current[index] === amount) {
          setter(result);
          setCardError(index, undefined);
        }
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptedLoanAssumption, aggregatedData?.user_credit, cashOutResults?.ltv]);

  useEffect(() => {
    setPropertyInfo(PropertyInfo.setPropertyInfo(currentLoanAssumptions));
  }, [currentLoanAssumptions]);

  const setCardButtonType = (cardIndex, buttonType) => {
    setAutoRecalculate((currentCards) => {
      const updatedCards = [...currentCards];
      updatedCards[cardIndex] = { buttonType };
      return updatedCards;
    });
  };

  const handleTotalLoanAmountChange = (index, val) => {
    setCardButtonType(index, null);
    if (index === 0) setTotalLoanAmountCardOne(val);
    if (index === 1) setTotalLoanAmountCardTwo(val);
    if (index === 2) setTotalLoanAmountCardThree(val);
  };

  const adjustedClosingCostsData = useMemo(() => {
    const totalLoanAmountsPerCard = [totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree];
    const selectedCards = [selectedCardOne, selectedCardTwo, selectedCardThree];

    const getLoanAmount = (index) => (isHomeEquity(selectedCards[index])
      ? (totalLoanAmountsPerCard[index] ?? 0)
      : (totalLoanAmountsPerCard[index] || initialTotalLoanAmount || currentLoanAssumptions?.estimatedMortageBalance));

    return ['card1', 'card2', 'card3'].map((cardKey, index) => {
      const activeClosingCosts = isHomeEquity(selectedCards[index]) ? helocClosingCostsData : refiClosingCostsData;
      if (!activeClosingCosts?.fundsAtClosing) return activeClosingCosts;

      const cardData = cardsMapData[cardKey];
      const baseClosingCosts = activeClosingCosts.fundsAtClosing.closingCosts ?? 0;
      const discountOrRebate = cardData?.discountOrRebate ?? 0;

      let adjustedClosingCosts = baseClosingCosts;
      let discountPoints = 0;

      if (cardData?.hasDiscount === true) {
        adjustedClosingCosts = baseClosingCosts + discountOrRebate;
        discountPoints = discountOrRebate;
      } else if (cardData?.hasDiscount === false) {
        adjustedClosingCosts = baseClosingCosts - discountOrRebate;
        discountPoints = -discountOrRebate;
      }

      const balance = parseFloat(currentLoanAssumptions?.estimatedMortageBalance) || 0;
      const thirtyDaysInterest = activeClosingCosts?.estimatedPrepaidExpenses?.interimInterestAmount ?? 0;
      const mip = calculateMIPByCardType(selectedCards[index], balance, thirtyDaysInterest);
      const cardNameNormalized = (selectedCards[index] ?? '').toLowerCase();
      const isFHACard = cardNameNormalized.includes('fha') || cardNameNormalized.includes('streamlined');
      const isVaCard = cardNameNormalized.includes('va');
      const mipRefund = isFHACard ? calculateMIPRefund(currentLoanAssumptions?.originalLoanVal, ficoInfo?.docDate) : 0;
      const noAppraisalFee = isStreamlinedOrIRRL(selectedCards[index]);
      const vaAppraisalFee = 800;
      const appraisalFeeOverride = noAppraisalFee ? (activeClosingCosts.estimatedClosingCosts?.appraisalFee ?? 0) : 0;

      let calculatedClosingCosts = Math.round(adjustedClosingCosts) + Math.round(mip);
      let calcAppraisalFee = activeClosingCosts.estimatedClosingCosts?.appraisalFee;
      if (noAppraisalFee) {
        calculatedClosingCosts -= Math.round(appraisalFeeOverride);
        calcAppraisalFee = 0;
      } else if (isVaCard && !noAppraisalFee) {
        calculatedClosingCosts += vaAppraisalFee;
        calcAppraisalFee = vaAppraisalFee;
      }

      return {
        ...activeClosingCosts,
        fundsAtClosing: {
          ...activeClosingCosts.fundsAtClosing,
          closingCosts: calculatedClosingCosts,
          calculatedLoanAmount: getLoanAmount(index),
          baseLoan: getLoanAmount(index),
          totalFundsAtClosing: cardData?.cashAtClosing != null ? -(cardData.cashAtClosing) || 0 : activeClosingCosts.fundsAtClosing.totalFundsAtClosing,
          mip: Math.round(mip),
          mipRefund: Math.round(mipRefund),
        },
        estimatedClosingCosts: {
          ...activeClosingCosts.estimatedClosingCosts,
          discountPoints: Math.round(discountPoints),
          initialPmi: Math.round(mip),
          appraisalFee: calcAppraisalFee,
        },
      };
    });
  }, [helocClosingCostsData, refiClosingCostsData, cardsMapData, selectedCardOne, selectedCardTwo, selectedCardThree, totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree, initialTotalLoanAmount, currentLoanAssumptions, ficoInfo?.docDate]);

  /**
    * MIN CASH TO CLOSING BUTTON
    * Calculates the loan amount needed so that Cash at Closing is approximately $0.
    *
    * Formula: Total Loan Amount = Current Balance + Second Loan + Closing Costs + Prepaid Expenses
    *
    * When discount/rebate applies, the formula adjusts algebraically:
    * - Discount points (price < 100): Loan = baseAmount / (1 - discountRate)
    * - Lender credit (price > 100): Loan = baseAmount / (1 + rebateRate)
    *
    * Note: After Optimal Blue reprices with the new loan amount, the final Cash at Closing
    * may vary slightly from $0 due to updated rates/prices. This is expected behavior.
  */
  const handleMinCashToClosing = useCallback((cardIndex) => {
    const selectedLoans = [selectedCardOne, selectedCardTwo, selectedCardThree];
    const activeClosingCosts = isHomeEquity(selectedLoans[cardIndex]) ? helocClosingCostsData : refiClosingCostsData;
    const cardDataMap = [cardOneData, cardTwoData, cardThreeData];
    const ratePrice = cardDataMap[cardIndex]?.price ?? 100;
    const adjustedLoanAmount = calculateTargetLoanAmount('minCash', activeClosingCosts, currentLoanAssumptions, ratePrice);
    setCardButtonType(cardIndex, 'minCash');
    setTotalLoanAmountForCard(cardIndex, Math.round(adjustedLoanAmount));
  }, [helocClosingCostsData, refiClosingCostsData, currentLoanAssumptions, cardOneData, cardTwoData, cardThreeData, selectedCardOne, selectedCardTwo, selectedCardThree, setTotalLoanAmountForCard]);

  /**
    * ONE PAYMENT BUTTON
    * Calculates the loan amount so that Cash at Closing equals approximately one current monthly payment.
    *
    * Formula: Total Loan Amount = Current Balance + Second Loan + Closing Costs + Prepaid - Current Payment
    *
    * When discount/rebate applies, the formula adjusts algebraically:
    * - Discount points (price < 100): Loan = baseAmount / (1 - discountRate)
    * - Lender credit (price > 100): Loan = baseAmount / (1 + rebateRate)
    *
    * The goal is to make Cash at Closing ≈ -currentPayment (e.g., -$2,530).
    *
    * Note: After Optimal Blue reprices with the new loan amount, the final Cash at Closing
    * may vary from the target due to updated rates/prices. This is expected behavior.
 */

  const handleOnePayment = useCallback((cardIndex) => {
    const selectedLoans = [selectedCardOne, selectedCardTwo, selectedCardThree];
    setCardButtonType(cardIndex, 'onePayment');
    const selectedLoan = selectedLoans[cardIndex];
    const ratePrice = [cardOneData, cardTwoData, cardThreeData][cardIndex]?.price ?? 100;
    if (isFHAStreamlined(selectedLoan)) {
      setTotalLoanAmountForCard(cardIndex, fhaStreamlinedDisplayAmount);
    } else if (isHomeEquity(selectedLoan)) {
      const adjustedLoanAmount = calculateTargetLoanAmount('onePayment', helocClosingCostsData, currentLoanAssumptions, ratePrice);
      setTotalLoanAmountForCard(cardIndex, Math.round(adjustedLoanAmount));
    } else {
      const adjustedLoanAmount = calculateTargetLoanAmount('onePayment', refiClosingCostsData, currentLoanAssumptions, ratePrice);
      const targetAmount = Number.isFinite(adjustedLoanAmount) && adjustedLoanAmount > 0
        ? Math.round(adjustedLoanAmount)
        : initialTotalLoanAmount;
      setTotalLoanAmountForCard(cardIndex, targetAmount);
    }
  }, [helocClosingCostsData, refiClosingCostsData, currentLoanAssumptions, cardOneData, cardTwoData, cardThreeData, selectedCardOne, selectedCardTwo, selectedCardThree, initialTotalLoanAmount, fhaStreamlinedDisplayAmount, setTotalLoanAmountForCard]);

  /**
    * MAX CASH OUT BUTTON
    * Calculates the maximum loan amount based on 80% Loan-to-Value (LTV) ratio.
    *
    * Formula: Total Loan Amount = Property Value × 0.8
    *
    * This sets the loan amount to the maximum allowed at 80% LTV, which maximizes
    * the cash available at closing. Unlike the other quick calculation buttons,
    * this calculation is independent of the selected rate/price and remains stable
    * after Optimal Blue repricing.
    */
  const handleMaxCashOut = useCallback((cardIndex) => {
    const { estimatedHomeValue } = currentLoanAssumptions;
    const selectedLoans = [selectedCardOne, selectedCardTwo, selectedCardThree];
    const cardLoanType = selectedLoans[cardIndex];
    let maxLoanAmount;
    if (isFHAStreamlined(cardLoanType)) {
      maxLoanAmount = fhaStreamlinedDisplayAmount;
    } else if (isHomeEquity(cardLoanType)) {
      maxLoanAmount = Math.round(((estimatedHomeValue ?? 0) * 0.8) - (currentLoanAssumptions?.estimatedMortageBalance ?? 0));
    } else {
      maxLoanAmount = Math.round((estimatedHomeValue ?? 0) * 0.8);
    }
    setCardButtonType(cardIndex, 'maxCash');
    setTotalLoanAmountForCard(cardIndex, maxLoanAmount);
  }, [currentLoanAssumptions, fhaStreamlinedDisplayAmount, selectedCardOne, selectedCardTwo, selectedCardThree, setTotalLoanAmountForCard]);

  const handleCardLoanAmountChange = useCallback((totalLoanAmount, selectedCard, cardData, setCardData, setIsCardLoading, selectedRate, cardIndex) => {
    if (!selectedCard) return;
    if (totalLoanAmount === 0) {
      if (isHomeEquity(selectedCard)) {
        setCardData(new LoanCompare({}, currentLoanAssumptions, 0, 0, selectedCard));
      }
      return;
    }
    if (isHomeEquity(selectedCard)) {
      if (totalLoanAmount < 10000) {
        setCardError(cardIndex, 'The loan amount must be at least $10,000');
        return;
      }
      const expectedAmount = totalLoanAmount;
      setCardError(cardIndex, undefined);
      setIsCardLoading(true);
      getHelocCardDataPerCard(selectedCard, totalLoanAmount, (msg) => setCardError(cardIndex, msg))
        .then((result) => {
          if (heAmountsRef.current[cardIndex] === expectedAmount) setCardData(result);
        })
        .finally(() => setIsCardLoading(false));
      return;
    }
    setCardError(cardIndex, undefined);

    if (!refiClosingCostsData?.fundsAtClosing?.calculatedLoanAmount) return;
    if (isInitialFetchRunning.current) return;
    if (initialFetchCompletedCardsRef.current.has(cardIndex)) {
      initialFetchCompletedCardsRef.current.delete(cardIndex);
      return;
    }

    const { estimatedHomeValue } = currentLoanAssumptions;
    const ltvAppraisedValue = (isFHAStreamlined(selectedCard) || isStreamlinedOrIRRL(selectedCard))
      ? (ficoInfo?.saleAmount || estimatedHomeValue)
      : estimatedHomeValue;
    const newLTV = calculateLTV(totalLoanAmount, ltvAppraisedValue);
    const previousLTV = cardData?.loanToValue ?? 0;

    const cashAtClosing = previewCashAtClosingForAmount(cardData, selectedCard, totalLoanAmount);
    const currentCashOut = autoRecalculate[cardIndex]?.buttonType !== 'onePayment'
      && autoRecalculate[cardIndex]?.buttonType !== 'minCash'
      && cashAtClosing > 0;

    const previousCashOut = previousCashOutRef.current[cardIndex];
    const isFHAOrVA = ficoInfo.loanType?.includes('FHA') || ficoInfo.loanType?.includes('VA');
    const cashOutChanged = !isFHAOrVA && previousCashOut !== currentCashOut;

    const currentOBInputs = buildOBInputsSnapshot(selectedCard);
    const previousOBInputs = previousOBInputsRef.current[cardIndex];
    const obInputsChanged = previousOBInputs !== null
      && Object.keys(currentOBInputs).some((key) => previousOBInputs[key] !== currentOBInputs[key]);

    if (cashOutChanged || obInputsChanged || shouldCallOB(previousLTV, newLTV, ficoInfo.loanType, currentCashOut, selectedCard) || !cardData?.interestRate || !!autoRecalculate[cardIndex]?.buttonType) {
      previousCashOutRef.current[cardIndex] = currentCashOut;
      previousOBInputsRef.current[cardIndex] = currentOBInputs;
      setIsCardLoading(true);
      getCardDataPerCard(selectedCard, totalLoanAmount, currentCashOut, aggregatedData, currentLoanAssumptions, refiClosingCostsData, selectedRate, cardIndex)
        .then((result) => {
          const recalculated = recalculateCardDataWithoutOB(result, totalLoanAmount, currentLoanAssumptions, refiClosingCostsData);
          setCardData(recalculated);
          updateRateOptions(cardIndex, recalculated);
          if (autoRecalculate[cardIndex]?.buttonType) {
            if (autoRecalculate[cardIndex].buttonType === 'minCash' || autoRecalculate[cardIndex].buttonType === 'onePayment') {
              if (!isFHAStreamlined(selectedCard)) {
                const adjustedLoanAmount = calculateTargetLoanAmount(autoRecalculate[cardIndex].buttonType, refiClosingCostsData, currentLoanAssumptions, result?.price || 100);
                if (Number.isFinite(adjustedLoanAmount) && adjustedLoanAmount > 0) {
                  setTotalLoanAmountForCard(cardIndex, Math.round(adjustedLoanAmount));
                }
              }
              setCardButtonType(cardIndex, null);
            } else {
              setCardButtonType(cardIndex, null);
            }
          }
        })
        .finally(() => setIsCardLoading(false));
    } else {
      previousCashOutRef.current[cardIndex] = currentCashOut;
      previousOBInputsRef.current[cardIndex] = currentOBInputs;
      const updatedCardData = recalculateCardDataWithoutOB(
        cardData,
        totalLoanAmount,
        currentLoanAssumptions,
        refiClosingCostsData,
      );
      setCardData(updatedCardData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refiClosingCostsData, currentLoanAssumptions, aggregatedData, getCardDataPerCard, getHelocCardDataPerCard, recalculateCashAtClosing, recalculateCardDataWithoutOB, autoRecalculate, setTotalLoanAmountForCard, buildOBInputsSnapshot]);

  useEffect(() => {
    const amount = isFHAStreamlined(selectedCardOne) ? fhaStreamlinedDisplayAmount : totalLoanAmountCardOne;
    handleCardLoanAmountChange(amount, selectedCardOne, cardOneData, setCardOneData, setIsCardOneLoading, selectedRateCardOne, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalLoanAmountCardOne, fhaStreamlinedDisplayAmount, refiClosingCostsData, selectedCardOne, aggregatedData, currentLoanAssumptions, getCardDataPerCard, getHelocCardDataPerCard, recalculateCashAtClosing, autoRecalculate]);

  useEffect(() => {
    const amount = isFHAStreamlined(selectedCardTwo) ? fhaStreamlinedDisplayAmount : totalLoanAmountCardTwo;
    handleCardLoanAmountChange(amount, selectedCardTwo, cardTwoData, setCardTwoData, setIsCardTwoLoading, selectedRateCardTwo, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalLoanAmountCardTwo, fhaStreamlinedDisplayAmount, refiClosingCostsData, selectedCardTwo, aggregatedData, currentLoanAssumptions, getCardDataPerCard, getHelocCardDataPerCard, recalculateCashAtClosing, autoRecalculate]);

  useEffect(() => {
    const amount = isFHAStreamlined(selectedCardThree) ? fhaStreamlinedDisplayAmount : totalLoanAmountCardThree;
    handleCardLoanAmountChange(amount, selectedCardThree, cardThreeData, setCardThreeData, setIsCardThreeLoading, selectedRateCardThree, 2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalLoanAmountCardThree, fhaStreamlinedDisplayAmount, refiClosingCostsData, selectedCardThree, aggregatedData, currentLoanAssumptions, getCardDataPerCard, getHelocCardDataPerCard, recalculateCashAtClosing, autoRecalculate]);

  const handleAmortizationClick = (cardId) => {
    setSelectedCardId(cardId);
    const cardLoanAmounts = { card1: totalLoanAmountCardOne, card2: totalLoanAmountCardTwo, card3: totalLoanAmountCardThree };
    const cardDataMap = { card1: cardOneData, card2: cardTwoData, card3: cardThreeData };
    const cardData = cardDataMap[cardId];
    amortizationRef.current?.open(
      cardLoanAmounts[cardId],
      cardData?.interestRate,
      cardData?.termInMonths,
    );
  };

  return (
    <main>
      <div className="headerDiv hide-on-print">
        <MortgageHeader />
      </div>
      <span className="hide-on-print">
        <span className={isMobile ? 'mobileHeaderApplyButton' : 'headerApplyButton'}>
          <Button id="apply_btn_top" data-test-id="apply_button_top" url={`${applyLink}`}>Apply now</Button>
        </span>
      </span>
      <TitleBanner loDetails={selectedLODetails} />
      <Col>
        <Row className="refiRow">
          {(error || clientError) && (!isSaveProposalModalOpen) && (
            <Row className="alertRow">
              <Alert showDivider={false} id="alert-message-api-error" variant="error" title="Error" data-test-id="api_error_alert">
                An error has occurred in this application. Please refresh the page and try again. If the error persists, please call Elevations at 800.460.2889.
              </Alert>
            </Row>
          )}
          <TopDataEntrySection
            onReasonChange={handleReasonChange}
            onAddressChange={handleAddressChange}
            onSelectedAddress={handlePropertyIdentifier}
            onCreditChange={handleCreditScore}
            loadedAddress={prospect?.application_data?.address || null}
            loadedCreditScore={prospect?.application_data?.user_credit ? prospect?.application_data?.user_credit : null}
            loadedReason={prospect?.application_data?.primary_reason || null}
          />
        </Row>
        {shouldShowPropertyModal && (
          <Row className="refiRow">
            <PropertyInfoPopUp
              results={propertyInfo}
              isOpen={shouldShowPropertyModal}
              propertyValue="1000000"
              onShowOptions={handlePropertyInfoShowOptions}
              onAdjustLoanAssumption={handlePropertyInfoAdjustLoanAssumption}
              onClose={handlePropertyInfoModalClose}
            />
          </Row>
        )}
        {isLoanAssumptionModalOpen && (
          <Row className="refiRow">
            <CurrentLoanAssumptionModal
              isOpen={isLoanAssumptionModalOpen}
              results={currentLoanAssumptions}
              onSave={handleCurrentLoanAssumptionModalSave}
              onClose={handleCurrentLoanAssumptionModalClose}
              getRemainingInterest={getRemainingInterest}
              getPrincipleInterest={getPrincipleInterest}
              getPropertyInsurance={getPropertyInsurance}
            />
          </Row>
        )}
        {isSaveProposalModalOpen && (
          <Row className="refiRow">
            <SaveProposalModal
              isOpen={isSaveProposalModalOpen}
              loanOfficersOptions={loanOfficers}
              results={saveProposalResults}
              onSaveAndSendLink={handleSaveProposalSubmit}
              closeModal={closeSaveProposalModal}
              apiError={apiPostError}
              isProspect={isProspect}
            />
          </Row>
        )}
        {emailSentModal && (
          <Modal
            contentOverrideClassName="emailModal"
            name="save-complete-modal"
            hideClose
            open={emailSentModal}
            data-test-id="email_sent_modal"
          >
            <Heading element="h3" size={3}>
              An email has been sent with a link back to this page
            </Heading>
            <Row>
              <Col>
                <p>
                  An email has been sent to the email address you entered. Please check your email for a link to your saved personalized page.
                  If you did not receive the email, please click Save again and verify your email address.
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button onClick={handleReturnToMyProposals} data-test-id="return_to_proposals_button">
                  Return to my proposals
                </Button>
              </Col>
            </Row>
          </Modal>
        )}
        {showPropertyTypeModalError && (
          <Modal
            contentOverrideClassName="emailModal"
            hideClose
            open={showPropertyTypeModalError}
            data-test-id="property_type_error_modal"
          >
            <Heading element="h3" size={3}>
              Property Type Issue
            </Heading>
            <Row>
              <Col>
                <p>
                  Due to the property type, we are unable to provide an online loan estimate. Feel free to contact us to discuss your options at 800.460.2889.
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button onClick={() => window.location.reload()} data-test-id="return_to_property_search_button">
                  Return to property search
                </Button>
              </Col>
            </Row>
          </Modal>
        )}
        {acceptedLoanAssumption && (
          <>
            <Row
              className="refiRow"
              ref={reasonRef}
            >
              <CurrentPayment
                showCurrentAssumptionsModal={handleLoanAssumptionsNewPayment}
                showSaveProposalModalFromHaveLoanOfficer={showSaveProposalModalFromHaveLoanOfficer}
                showSaveProposalModalFromSaveForLater={showSaveProposalModalFromSaveForLater}
                selectedCardId={selectedCardId}
                currentAssumptions={currentLoanAssumptions}
                applyUrl={applyLink}
                isProspect={isProspect}
              />
            </Row>
            <Row className="">
              <Col className="refiCol">
                <p className="rateDate" data-test-id="rate_date_paragraph">
                  Rates as of
                  {' '}
                  {rateDate}
                </p>
              </Col>

            </Row>
            <Row className="refiLoanCompareRow">
              <CardsComponent
                totalLoanAmounts={[totalLoanAmountCardOne, totalLoanAmountCardTwo, totalLoanAmountCardThree]}
                onTotalLoanAmountChange={handleTotalLoanAmountChange}
                loanOfficersOptions={loanOfficers}
                cardOneData={getDisplayCardData(cardOneData)}
                setCardOneSelected={(loan) => handleCardChange(0, loan)}
                cardTwoData={getDisplayCardData(cardTwoData)}
                setCardTwoSelected={(loan) => handleCardChange(1, loan)}
                cardThreeData={getDisplayCardData(cardThreeData)}
                setCardThreeSelected={(loan) => handleCardChange(2, loan)}
                applyUrl={applyLink}
                isOpen={isNewPaymentSectionOpen}
                setIsOpen={setIsNewPaymentSectionOpen}
                loanType={ficoInfo.loanType}
                reasonForLoan={aggregatedData.refiReason}
                selectedLoanType={selectedLoanType}
                setSelectedLoanType={setSelectedLoanType}
                closingCosts={adjustedClosingCostsData}
                moreInfoDataPoints={moreInfoDataPoints}
                selectedCardId={selectedCardId}
                setSelectedCardId={setSelectedCardId}
                onAmortizationClick={handleAmortizationClick}
                isShowMore={loanCompareSectionShowMore}
                setIsShowMore={setLoanCompareSectionShowMore}
                rateDataOptions={rateOptions}
                onRateUpdate={handleRateUpdate}
                onMaxCashOut={handleMaxCashOut}
                onMinCashToClosing={handleMinCashToClosing}
                onOnePayment={handleOnePayment}
                enableRatePicker
                cardLoadingStates={[isCardOneLoading, isCardTwoLoading, isCardThreeLoading]}
                cardErrors={cardErrors}
                cardOneVisible={cardOneVisible}
                cardTwoVisible={cardTwoVisible}
                cardThreeVisible={cardThreeVisible}
                onRemoveCard={handleRemoveCard}
                onAddCard={handleAddCard}
                newCardIndex={newCardIndex}
              />
            </Row>
            <br />
            <AmortizationTable
              ref={amortizationRef}
              loanAmount={{ card1: totalLoanAmountCardOne, card2: totalLoanAmountCardTwo, card3: totalLoanAmountCardThree }[selectedCardId] ?? 0}
              interestRate={cardsMapData[selectedCardId]?.interestRate}
              termMonths={cardsMapData[selectedCardId]?.termInMonths}
              amortization="1"
              propertyValue={propertyInfo?.propertyValue}
              estimateTipmi="Y"
              propertyTaxes={null}
              hazardInsurance={null}
              pmi={null}
            />
          </>
        )}
      </Col>
    </main>
  );
}

export const NewUserRouteNoLoanOfficer = {
  path: '/',
  element: <NewUser />,
  loader: async () => {
    const loDetails = {};
    return { ...loDetails };
  },
  errorElement: <NewUser error />,
};

export const NewUserRouteWithLoanOfficer = {
  path: ':userId',
  element: <NewUser />,
  loader: async ({ params }) => {
    try {
      const prospectUrl = `${process.env.REACT_APP_MCCC_API_URL}/refi/prospect/${params.userId}`;
      const prospect = await axios.get(prospectUrl);
      if (!prospect.data) {
        throw new Error('No data received from server');
      }

      return { ...prospect.data };
    } catch (error) {
      console.error('Error fetching loan officer data:', error);
      throw error;
    }
  },
  errorElement: <NewUser error />,
};

export { NewUser };
export default NewUser;
